

// TODO P3.2 strict migration: pending
import { catalogPackingPositions, readCatalogInventory } from './catalog-order.ts';
import { zestawAllegroChip } from './zestaw-allegro.ts';
import { ulozZdjeciaPozycji, zrodloZdjecZKonfigu, zdjecieOfertyDlaPozycji, pozycjaZamowieniaDlaPozycji, type ZrodloZdjec } from './packing-images.ts';
import { pozycjeZestawu, pozycjeKomponentow, mapaSkladuZPozycji, uzupelnijPozycjeKatalogu, grupujPozycje, grupaGotowa, licznikGrup, daneBraku, type DaneBraku } from './packing-sklad.ts';
import { wygasIUsun, zapamietajWidok } from './plynne.ts';
import { adresPlikuPrywatnego } from './media-token.ts';
import { zamowienieWidoczneWFiltrze, isOrdersGlobalSearchActive } from './orders-shared.ts'; // S-139 przegląd: ten sam warunek co pasek filtra
import { onInvalidate } from './sse-client.ts';
/**
 * src/modules/packing.js — Faza C.3.packing → Faza D.3.2 ESM migration
 *
 * Native ES module. Backward-compat: window.X exposures zachowane na końcu.
 */


// FIX (Faza E.1, 2026-04-29): Lazy state proxy — packing teraz importowane przez orders-list (ESM)
// może wykonać się PRZED app.js. Bez proxy crash 'Cannot read properties of undefined'.
// Sprint 23 (2026-05-02): typ `any` żeby ad-hoc properties (packingOrderId, packingLocks) nie wymagały typów.
var state: any = (typeof window !== 'undefined' && (window as any).__sbState) || (function() {
  var _p = new Proxy({} as any, {
    get: function(_: any, k: any) { return (window as any).__sbState ? (window as any).__sbState[k] : undefined; },
    set: function(_: any, k: any, v: any) { if ((window as any).__sbState) (window as any).__sbState[k] = v; return true; },
    has: function(_: any, k: any) { return (window as any).__sbState ? (k in (window as any).__sbState) : false; },
  });
  return _p;
})();
// 2026-06-10: token aktywnego auto-flow WzA per orderId. Chroni przed podwojnym
// _finishFlow (podwojny wydruk + podwojny PUT statusu) gdy user kliknie SPAKOWANE
// drugi raz przy zywym watcherze albo gdy powstana dwa rownolegle przebiegi.
// _finishFlow / watcher dziala tylko gdy ich orderId == _activeFlowOrderId.
var _activeFlowOrderId: any = null;

// AUDYT 2026-08-11: po mutacji lista MUSI dostac SWIEZE dane — render ze starego
// store'u + cache strony (sessionStorage, TTL 60 s) pokazywal stan sprzed zmiany
// az do F5. Inwalidacja cache + wymuszony refetch (force omija juz sessionStorage).
// S-139 (07.10.2026): spakowane zamówienie wypadało z listy razem z CAŁĄ listą (pełne
// renderOrderCards po refetchu) — karty pod nim skakały w górę. Gdy filtr statusu nie
// jest "Wszystkie" (gdzie karta i tak zostaje, tylko z innym statusem — tam wygaszanie
// migałoby na niepotrzebnie), spakowane zamówienie wygasamy PUNKTOWO zaraz PRZED
// refetchem: do czasu aż dociągną się świeże dane, lista jest już wizualnie w stanie
// docelowym, więc pełne przerysowanie nie "skacze". Dociągnięcie kolejnej pozycji na
// stronę (po zdjęciu jednej) i tak robi loadAllegroOrdersIntoPanel(true) niżej.
// S-139 przegląd: `nowyKlucz` — gdy wołający ZNA wynikowy status (np. „shipped” po udanym PUT),
// decyzję o wygaszeniu podejmuje `zamowienieWidoczneWFiltrze` (uwzględnia też aktywne globalne
// wyszukiwanie — stary blankietowy warunek `filtr !== 'all'` je ignorował). `null` = wołający
// wie, że mutacja się NIE powiodła (np. PUT statusu padł) — karta zostaje, bez wygaszania.
// `undefined` (domyślnie, wołający nie podał) = stara heurystyka audytu, niezmieniona.
// 19.10.2026 (właściciel: „jak się normalnie kliknie spakuj paczkę, to też na dół przerzuca, ale nie zawsze”):
// start pakowania centrował kartę `scrollIntoView({block:'center'})` — karta w dolnej części listy nie da się
// wycentrować, więc lista (i dokument, mimo overflow:hidden) leciała na sam dół i tam zostawała po pakowaniu.
// Teraz: przewinięcie tylko listy i tylko gdy karty nie widać, a po zakończeniu / anulowaniu pakowania
// powrót dokładnie do miejsca sprzed kliknięcia „Spakuj”.
var _przewiniecieSprzedPakowania: null | (() => void) = null;

function _pokazKarteBezSkoku(karta: Element): void {
  var main = (karta as HTMLElement).closest('.main-content') as HTMLElement | null;
  if (!main) return;
  var r = karta.getBoundingClientRect();
  var m = main.getBoundingClientRect();
  if (r.top >= m.top && r.bottom <= m.bottom) return;  // widać w całości — nic nie ruszamy
  var cel = main.scrollTop + (r.top - m.top) - Math.max(0, (main.clientHeight - r.height) / 2);
  try { main.scrollTo({ top: Math.max(0, cel), behavior: 'smooth' }); } catch (_e) { main.scrollTop = Math.max(0, cel); }
}

function _wrocDoMiejscaSprzedPakowania(): void {
  var przywroc = _przewiniecieSprzedPakowania;
  _przewiniecieSprzedPakowania = null;
  if (przywroc) { try { przywroc(); } catch (_e) { /* best-effort */ } }
}

function _odswiezListeZamowienPoMutacji(orderId?: any, nowyKlucz?: string | null) {
  // przewinięcie po wyjściu z pakowania (już przywrócone) zostaje też po przerysowaniu listy
  var przywrocWidok = zapamietajWidok(document.getElementById('orders-list-container'));
  try {
    var wygasic = false;
    if (orderId != null) {
      if (nowyKlucz !== undefined) {
        wygasic = !!nowyKlucz && !zamowienieWidoczneWFiltrze(nowyKlucz);
      } else {
        // S-139 przegląd 2: przy globalnym wyszukiwaniu filtr paska nie obowiązuje — karta nie gaśnie (wróciłaby po refetchu)
        wygasic = !isOrdersGlobalSearchActive() && String((state && state.ordersStatusFilter) || 'all') !== 'all';
      }
    }
    if (wygasic) {
      var karty = document.querySelectorAll('.order-card');
      for (var i = 0; i < karty.length; i++) {
        if ((karty[i] as HTMLElement).dataset.orderId === String(orderId)) { wygasIUsun(karty[i]); break; }
      }
    }
  } catch (_e) {}
  try {
    var inv: any = (window as any)._invalidateOrdersPageCache;
    if (typeof inv === 'function') inv();
  } catch (_e) {}
  try {
    var ld: any = (window as any).loadAllegroOrdersIntoPanel
      || ((window as any).SellBaseApp || {}).loadAllegroOrdersIntoPanel;
    if (typeof ld === 'function') Promise.resolve(ld(true)).then(przywrocWidok, przywrocWidok);
  } catch (_e) {}
}


// 2026-07-06: fetch z twardym timeoutem (AbortController). Surowe fetche flow pakowania
// szły bez abort — na prodzie (HTTP/1.1, max ~6 połączeń/host) zawieszony request trzymał
// slot połączenia NA STAŁE; po serii pakowań pool się wyczerpywał i kolejne żądania
// (m.in. loadery drawera) wisiały → "wieczne Ładowanie wymagające F5". Timeout zwalnia slot.
function _fetchWT(url: string, opts: any, ms?: number): Promise<Response> {
  var _ms = ms || 12000;
  var _ac = (typeof AbortController !== 'undefined') ? new AbortController() : null;
  var _to: any = null;
  if (_ac) {
    opts = opts || {};
    opts.signal = _ac.signal;
    _to = setTimeout(function () { try { _ac!.abort(); } catch (_) {} }, _ms);
  }
  return fetch(url, opts).finally(function () { if (_to) clearTimeout(_to); });
}

// Telemetria procesu jest best-effort i nie może wpływać na właściwy tor
// pakowania. Zapisujemy ukończenie dopiero po potwierdzonym statusie shipped.
async function _completePackingProcessSession(orderId: any, shipmentId?: any): Promise<any> {
  var w = window as any;
  var token = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken())
    || localStorage.getItem('sellbase_token') || '';
  var canonicalOrderId = String(orderId || '').replace(/^(AL|EB|ER|PS|TT|VH)-/i, '');
  if (canonicalOrderId.indexOf(':') < 0) canonicalOrderId = canonicalOrderId.toLowerCase();
  var response = await _fetchWT('/api/packing/session/complete', {
    method: 'POST',
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      order_id: canonicalOrderId,
      shipment_id: shipmentId ? Number(shipmentId) : null,
    }),
  });
  var payload: any = {};
  try { payload = await response.json(); } catch (_) {}
  if (!response.ok || !payload || payload.ok !== true) {
    var detail = String((payload && (payload.detail || payload.error)) || ('HTTP ' + response.status));
    throw new Error(detail);
  }
  return payload;
}
// (Sprint 23) navigate forwarder unused — comment out
function normalizeBackendOrder(this: any, ...args: any[]) { return ((window as any).__sbExports && (window as any).__sbExports.normalizeBackendOrder || (window as any).normalizeBackendOrder).apply(this, args); }

  // ── 2026-08-26 (zgłoszenie usera): okienko „poprzednio spakowane" ──
  // Pakowacz kończy zamówienie A, zaczyna B — i orientuje się, że w A czegoś
  // zapomniał (dorzucić do paczki, poprawić, dodrukować etykietę). Chip w lewym
  // dolnym rogu modala pakowania pokazuje JEGO poprzednio spakowane zamówienie
  // i jednym klikiem otwiera je z powrotem w widoku pakowania.
  // localStorage per użytkownik: przeżywa F5, a na wspólnym stanowisku po
  // przelogowaniu każdy widzi swoje.
  function _poprzednieKlucz() {
    var w = window as any;
    var u = w.currentUser || (w.__sbState && w.__sbState.currentUser)
      || (w.SellBaseApp && w.SellBaseApp.state && w.SellBaseApp.state.currentUser) || {};
    return 'sellbase_ostatnio_spakowane:' + String((u && u.id) || 'anon');
  }
  function _zapiszPoprzednie(orderId: any, orderObj: any) {
    try {
      var etykieta = String((orderObj && (orderObj.orderNumber || orderObj.order_number)) || orderId || '');
      var kupujacy = String((orderObj && (orderObj.customer || orderObj.buyer_name || orderObj.buyerLogin || orderObj.buyer_login)) || '').trim();
      // 2026-08-26 (iteracja 3): klik ma otwierać KARTĘ zamówienia
      // (/orders/{ID}) — najlepszy identyfikator do linku to public_id (ULID),
      // fallback: surowe id (router order-detail przyjmuje oba).
      var pub = String((orderObj && (orderObj.public_id || orderObj.source_order_id || orderObj.id)) || orderId || '');
      localStorage.setItem(_poprzednieKlucz(), JSON.stringify({
        id: String(orderId), pub: pub, label: etykieta.slice(0, 40), buyer: kupujacy.slice(0, 60),
        at: new Date().toISOString(),
      }));
    } catch (_) { /* pamiątka, nie warunek */ }
  }
  function _czytajPoprzednie(): any {
    try {
      var d = JSON.parse(localStorage.getItem(_poprzednieKlucz()) || 'null');
      return (d && d.id && !d.hidden) ? d : null;
    } catch (_) { return null; }
  }
  function _pmEsc(t: any): string {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function(c: any) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as any)[c];
    });
  }
  function _renderPoprzednieOkienko() {
    // POPRAWKA 2026-08-26 (druga iteracja zgłoszenia): „jak ktoś kliknie
    // SPAKOWANE WYŚLIJ, modal się zamyka (…) chcę, aby mógł przejść od razu
    // do poprzedniego zamówienia, czyli aby było POZA modalem, w lewym dolnym
    // rogu". Pierwsza wersja siedziała w stopce modala — widać ją było dopiero
    // przy KOLEJNYM pakowaniu. Teraz okienko pływa w lewym dolnym rogu obszaru
    // roboczego (fixed, w #view-orders — znika razem z widokiem zamówień),
    // z z-index 899: NAD przyciemnieniem trybu pakowania (898), POD modalem
    // (900) — więc widać je i po zamknięciu modala, i w trakcie pakowania.
    var stary = document.getElementById('pm-prev-float');
    if (stary && stary.parentNode) stary.parentNode.removeChild(stary);
    var d = _czytajPoprzednie();
    if (!d) return;
    // nie pokazuj okienka wskazującego na zamówienie właśnie otwarte w pakowaniu
    if (state.packingDrawerOpen && String(state.packingOrderId) === String(d.id)) return;
    var widok = document.getElementById('view-orders');
    if (!widok) return;
    var box = document.createElement('div');
    box.id = 'pm-prev-float';
    var krotkiNr = String(d.label || d.id);
    if (krotkiNr.length > 20) krotkiNr = krotkiNr.slice(0, 18) + '…';
    // Iteracja 3 (user): „większe, czytelniejsze" — numer 14px/700, kupujący
    // osobną linią; klik prowadzi na KARTĘ zamówienia, nie do modala pakowania.
    box.innerHTML = ''
      + '<button type="button" id="pm-prev-float-go" title="Otwórz kartę poprzednio spakowanego zamówienia">'
      +   '<i data-lucide="undo-2" style="width:18px;height:18px;flex-shrink:0;color:var(--color-primary)"></i>'
      +   '<span style="overflow:hidden;text-align:left;min-width:0">'
      +     '<span style="display:block;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.65;margin-bottom:2px">Poprzednio spakowane</span>'
      +     '<strong style="display:block;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">#' + _pmEsc(krotkiNr) + '</strong>'
      +     (d.buyer ? '<span style="display:block;font-size:12px;color:var(--color-text-muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + _pmEsc(String(d.buyer).slice(0, 34)) + '</span>' : '')
      +   '</span>'
      + '</button>'
      + '<button type="button" id="pm-prev-float-x" title="Ukryj" aria-label="Ukryj">✕</button>';
    widok.appendChild(box);
    try { (window as any).lucide && (window as any).lucide.createIcons({ nodes: [box] }); } catch (_) {}
    var go = document.getElementById('pm-prev-float-go');
    if (go) go.addEventListener('click', async function() {
      // Iteracja 3 (user): klik przenosi na KARTĘ zamówienia (/orders/{ID}),
      // nie otwiera modala pakowania. Gdy trwa INNE pakowanie z zebranymi
      // pozycjami — potwierdzenie, bo karta otworzyłaby się POD modalem.
      var potwierdzone = 0;
      try {
        if (state.packingDrawerOpen && _pmSession
            && String(_pmSession.orderId) === String(state.packingOrderId)) {
          potwierdzone = _pmSession.positions.filter(function(pz: any) { return pz.confirmed; }).length;
        }
      } catch (_) {}
      if (state.packingDrawerOpen && potwierdzone > 0) {
        var wcf = (window as any);
        var cf = (wcf.__sbExports && wcf.__sbExports.showConfirm) || wcf.showConfirm;
        if (typeof cf === 'function') {
          var ok = await cf('Przejść do poprzedniego zamówienia?',
            'Obecne pakowanie zostanie przerwane (zebrane pozycje: ' + potwierdzone + '). Kontynuować?',
            { danger: true });
          if (!ok) return;
        }
      }
      // Otwarte pakowanie zamykamy — inaczej karta wjedzie POD modal (z-900).
      if (state.packingDrawerOpen && state.packingOrderId) {
        try { _cancelPacking(state.packingOrderId); } catch (_) {}
      }
      var w2 = window as any;
      var nav = (w2.__sbExports && w2.__sbExports.navigate) || w2.navigate;
      if (typeof nav === 'function') nav('/orders/' + encodeURIComponent(String(d.pub || d.id)));
    });
    var x = document.getElementById('pm-prev-float-x');
    if (x) x.addEventListener('click', function() {
      // Ukryj do następnego spakowania — bez kasowania pamięci (F5 je przywróci
      // dopiero po kolejnym „Spakowane", bo zapis nadpisze flagę ukrycia).
      try { var d2 = _czytajPoprzednie(); if (d2) { d2.hidden = true; localStorage.setItem(_poprzednieKlucz(), JSON.stringify(d2)); } } catch (_) {}
      var el = document.getElementById('pm-prev-float');
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  // Faza C.3.orders-list — orders-list (1184 linii) extracted to src/modules/orders-list.js
  function togglePacking(orderId: any) {
    if (state.packingOrderId === orderId && state.packingDrawerOpen) {
      _cancelPacking(orderId);
    } else {
      if (state.packingDrawerOpen && state.packingOrderId) {
        _cancelPacking(state.packingOrderId);
      }
      _startPacking(orderId);
    }
  }

  // 2026-07-08 PRZYCISK "GENERUJ ETYKIETĘ": etykiety wydrukowane przyciskiem w tej sesji
  // pakowania — "Spakowane — wyślij" pomija wtedy drugi wydruk (tylko status).
  var _labelDoneByButton: Record<string, any> = {};

  // ── Z7 (28.10.2026, zgłoszenie #7): zamówienie anulowane w marketplace przy otwartym oknie pakowania ──
  // Okno rysuje się z pamięci listy i nie znało świeżego statusu — pracownik pakował i kupował etykietę.
  // Pasek na górze okna + wyłączone „Generuj etykietę” i „Spakowane — wyślij”. Backend i tak odmawia (409).
  var KOMUNIKAT_ANULOWANE = 'Zamówienie anulowane – nie pakuj';
  var _pmAnulowane: Record<string, boolean> = {};
  // S-222 (29.10.2026, dubel 128917): „spakował już ktoś inny” — ten sam pasek i blokada przycisków co Z7, inny tekst.
  // Backend: 409 PACKED_BY_OTHER z /api/packing/lock i `packed_by_other` z /api/packing/order-status.
  var KOMUNIKAT_SPAKOWANE = 'Spakował już ktoś inny – nie pakuj drugi raz';
  var _pmSpakowane: Record<string, string> = {};
  function _bladSpakowanePrzezInnego(e: any): boolean {
    return !!(e && ((e.detail && e.detail.code === 'PACKED_BY_OTHER') || e.code === 'PACKED_BY_OTHER'));
  }
  function _pmTekstBlokady(orderId: any): string { return _pmSpakowane[String(orderId)] || KOMUNIKAT_ANULOWANE; }

  function _bladAnulowania(e: any): boolean {
    return !!(e && ((e.detail && e.detail.code === 'ORDER_CANCELLED') || e.code === 'ORDER_CANCELLED'));
  }

  function _idKanoniczne(id: any): string {
    var v = String(id || '').replace(/^(AL|EB|ER|PS|TT|VH)-/i, '');
    return v.indexOf(':') < 0 ? v.toLowerCase() : v;
  }

  function _pmZablokujPrzyciski() {
    ['packing-genlabel-btn', 'packing-complete-btn'].forEach(function(id) {
      var b = document.getElementById(id) as HTMLButtonElement | null;
      if (!b) return;
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      b.setAttribute('data-anulowane', '1');
      b.title = KOMUNIKAT_ANULOWANE;
    });
  }

  function _pmOznaczAnulowane(orderId: any) {
    if (!orderId || String(state.packingOrderId) !== String(orderId)) return;
    _pmAnulowane[String(orderId)] = true;
    _pmPokazPasekBlokady(KOMUNIKAT_ANULOWANE);
    _pmZablokujPrzyciski();
  }

  // S-222: zamówienie spakował już ktoś inny — czerwony pasek z nazwiskiem i godziną, przyciski wyłączone.
  function _pmOznaczSpakowane(orderId: any, tekst: string) {
    if (!orderId || String(state.packingOrderId) !== String(orderId)) return;
    _pmSpakowane[String(orderId)] = String(tekst || '').trim() || KOMUNIKAT_SPAKOWANE;
    _pmPokazPasekBlokady(_pmSpakowane[String(orderId)]);
    _pmZablokujPrzyciski();
  }

  function _pmPokazPasekBlokady(tekst: string) {
    var modal = document.querySelector('#packing-drawer .pm-modal');
    if (!modal) return;
    var pasek = document.getElementById('pm-anulowane-pasek');
    if (!pasek) {
      pasek = document.createElement('div');
      pasek.id = 'pm-anulowane-pasek';
      pasek.className = 'pm-anulowane-pasek';
      pasek.setAttribute('role', 'alert');
      pasek.style.cssText = 'background:var(--color-error,#dc2626);color:#fff;font-weight:700;font-size:15px;'
        + 'line-height:1.3;padding:10px 16px;text-align:center;flex:0 0 auto';
      var head = modal.querySelector('.pm-head');
      modal.insertBefore(pasek, head ? head.nextSibling : modal.firstChild);
    }
    pasek.textContent = tekst;
  }

  // Nowa sesja pakowania: bez paska i z przyciskami, które zablokowała poprzednia (tylko nasze — data-anulowane).
  function _pmWyczyscAnulowane(orderId: any) {
    delete _pmAnulowane[String(orderId)];
    delete _pmSpakowane[String(orderId)];  // S-222
    var pasek = document.getElementById('pm-anulowane-pasek');
    if (pasek && pasek.parentNode) pasek.parentNode.removeChild(pasek);
    var b = document.getElementById('packing-complete-btn') as HTMLButtonElement | null;
    if (b && b.getAttribute('data-anulowane') === '1') {
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      b.removeAttribute('data-anulowane');
      b.title = '';
    }
  }

  // Świeży status z backendu (tylko baza). True = anulowane (pasek pokazany). Błąd sieci = false — backend blokuje 409.
  async function _pmSprawdzAnulowane(orderId: any): Promise<boolean> {
    if (_pmAnulowane[String(orderId)]) return true;
    if (_pmSpakowane[String(orderId)]) return true;  // S-222: spakował już ktoś inny — też blokada
    try {
      var r = await fetch('/api/packing/order-status?order_id=' + encodeURIComponent(String(orderId)),
        { headers: { 'Authorization': 'Bearer ' + _pmTok() } });
      if (!r.ok) return false;
      var j = await r.json().catch(function() { return {}; });
      if (j && j.cancelled) { _pmOznaczAnulowane(orderId); return true; }
      if (j && j.packed_by_other) {  // S-222
        _pmOznaczSpakowane(orderId, String((j.packed_by_other && j.packed_by_other.message) || KOMUNIKAT_SPAKOWANE));
        return true;
      }
    } catch (_) {}
    return false;
  }

  // SSE `invalidate/orders` dla otwartego zamówienia (sync z kanału zmienił status) → sprawdź od razu.
  try {
    onInvalidate('orders', function(extra: any) {
      if (!state.packingDrawerOpen || !state.packingOrderId) return;
      var oid = extra && extra.order_id;
      if (!oid || _idKanoniczne(oid) !== _idKanoniczne(state.packingOrderId)) return;
      _pmSprawdzAnulowane(state.packingOrderId);
    });
  } catch (_) { /* SSE niedostępne — zostaje poller blokad */ }

  // 2026-07-10: przycisk jest ZAWSZE dostępny (usunięto toggle z Ustawień). Pobieramy
  // per zamówienie stan: czy etykieta już istnieje → wtedy przycisk „Drukuj" (nie „Generuj").
  async function _fetchLabelState(orderId: any): Promise<any> {
    try {
      var w = window as any;
      var tk = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
      var r = await fetch('/api/packing/label-button?order_id=' + encodeURIComponent(String(orderId)), { headers: { 'Authorization': 'Bearer ' + tk } });
      return r.ok ? await r.json() : { enabled: true, has_label: false };
    } catch (_) { return { enabled: true, has_label: false }; }
  }

  function _renderGenLabelButton(orderId: any, hasLabel?: boolean) {
    var footer = document.getElementById('packing-drawer-footer');
    if (!footer) return;
    // Jeśli w tej sesji już wydrukowano przyciskiem — nie nadpisuj stanu „WYDRUKOWANA".
    if (_labelDoneByButton[orderId]) return;
    var old = document.getElementById('packing-genlabel-btn');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var btn = document.createElement('button');
    btn.id = 'packing-genlabel-btn';
    // MODAL 2.0: przycisk żyje w prawej części stopki, przed „Spakowane — wyślij".
    btn.className = 'pm-label-btn';
    // Etykieta już istnieje → tryb DRUKUJ (zielona ramka), inaczej GENERUJ (ramka primary).
    if (hasLabel) {
      btn.setAttribute('data-has-label', '1');
      btn.style.cssText = 'border-color:var(--color-success,#22c55e);color:var(--color-success,#22c55e);line-height:1.25';
      btn.title = 'Etykieta dla tego zamówienia jest już wygenerowana — klik tylko ją drukuje (bez tworzenia nowej).';
      btn.innerHTML = '<i data-lucide="printer" style="width:16px;height:16px"></i> DRUKUJ ETYKIETĘ'
        + '<span style="display:block;font-size:10px;font-weight:400;opacity:.85;margin-top:1px">etykieta już wygenerowana</span>';
    } else {
      btn.innerHTML = '<i data-lucide="printer" style="width:16px;height:16px"></i> GENERUJ ETYKIETĘ';
    }
    var footRight = document.getElementById('pm-foot-right');
    var shipBtnEl = document.getElementById('packing-complete-btn');
    if (footRight) footRight.insertBefore(btn, shipBtnEl && shipBtnEl.parentNode === footRight ? shipBtnEl : footRight.firstChild);
    else footer.insertBefore(btn, footer.firstChild);
    try { (window as any).lucide && (window as any).lucide.createIcons({ nodes: [btn] }); } catch (_) {}
    if (_pmAnulowane[String(orderId)] || _pmSpakowane[String(orderId)]) _pmZablokujPrzyciski();  // Z7/S-222: przerysowanie nie odblokowuje

    btn.addEventListener('click', async function() {
      var w = window as any;
      // Z7: świeży status przed etykietą — anulowane = pasek, bez wywołania generate-label
      if (await _pmSprawdzAnulowane(orderId)) { showToast(_pmTekstBlokady(orderId), 'error'); return; }
      var _origHtml = btn.innerHTML;  // zachowaj tryb (Drukuj vs Generuj) do resetu przy błędzie
      var _isPrintMode = btn.getAttribute('data-has-label') === '1';
      (btn as any).disabled = true;
      btn.innerHTML = '<i data-lucide="loader-2" style="width:16px;height:16px;animation:spin 1s linear infinite"></i> ' + (_isPrintMode ? 'Przygotowanie…' : 'Generowanie…');
      try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
      try {
        var tk = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
        var resp = await fetch('/api/packing/generate-label', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + tk, 'Content-Type': 'application/json' },
          body: JSON.stringify({ order_id: String(orderId) }),
        });
        var j = await resp.json().catch(function() { return {}; });
        if (resp.ok && j && j.ok && j.shipment_id) {
          btn.innerHTML = '<i data-lucide="printer" style="width:16px;height:16px;animation:spin 1s linear infinite"></i> Drukowanie…';
          try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
          var _drukOk = false;
          var _drukBlad = 'brak modułu druku';
          try {
            var printFn = (w.__sbExports && w.__sbExports.sellbasePrintShipmentLabel) || w.sellbasePrintShipmentLabel;
            if (typeof printFn === 'function') {
              var _wynikDruku = await printFn({ shipment_id: j.shipment_id, document_type: 'shipping_label', miejsce: 'pakowanie' });
              // 2026-08-27 (zgłoszenie: etykieta na innej drukarce niż test) —
              // mówimy wprost, DOKĄD poszła; rozjazd konfiguracji helpera widać
              // od razu, zamiast być zagadką przy drukarce.
              if (_wynikDruku && _wynikDruku.ok && _wynikDruku.printer) {
                try { showToast('Etykieta → ' + _wynikDruku.printer, 'info'); } catch (_te) {}
              }
              _drukOk = !!(_wynikDruku && _wynikDruku.ok);
              _drukBlad = String((_wynikDruku && _wynikDruku.error) || 'helper offline');
            }
          } catch (pe: any) { console.warn('[gen-label] print failed (helper offline?)', pe); _drukBlad = String((pe && pe.message) || 'błąd druku'); }
          if (!_drukOk) {
            // 21.10.2026 (audyt K7-3-U2): przycisk oznaczał „ETYKIETA WYDRUKOWANA” bez względu na wynik druku, a potem
            // „Spakowane” pomijało druk (skip_print) — paczka bez etykiety w ręku. Ponowny klik używa tej samej
            // przesyłki (generate-label zwraca istniejącą), więc nie kupuje drugiej etykiety.
            showToast('Etykieta NIE wydrukowana: ' + _drukBlad + ' — kliknij przycisk ponownie', 'warning');
            (btn as any).disabled = false;
            btn.innerHTML = '<i data-lucide="printer" style="width:16px;height:16px"></i> DRUKUJ PONOWNIE';
            btn.style.borderColor = 'var(--color-warning,#f59e0b)';
            btn.style.color = 'var(--color-warning,#f59e0b)';
            try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
            return;
          }
          _labelDoneByButton[orderId] = j.shipment_id;
          btn.innerHTML = '<i data-lucide="check-circle" style="width:16px;height:16px"></i> ETYKIETA WYDRUKOWANA' + (j.reused ? ' (istniejąca)' : '');
          btn.style.borderColor = 'var(--color-success,#22c55e)';
          btn.style.color = 'var(--color-success,#22c55e)';
          try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
        } else if (_bladAnulowania(j) || _bladAnulowania({ detail: j && j.detail })) {
          showToast(KOMUNIKAT_ANULOWANE, 'error');  // Z7: backend odmówił — anulowane w trakcie
          _pmOznaczAnulowane(orderId);
        } else {
          var msg = (j && (j.message || j.detail)) || 'Nie udało się wygenerować etykiety';
          showToast(String(msg), 'error');
          (btn as any).disabled = false;
          btn.innerHTML = _origHtml;  // przywróć tryb (Drukuj/Generuj)
          try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
        }
      } catch (e) {
        showToast('Błąd generowania etykiety — spróbuj ponownie', 'error');
        (btn as any).disabled = false;
        btn.innerHTML = _origHtml;  // przywróć tryb (Drukuj/Generuj)
        try { (window as any).lucide && (window as any).lucide.createIcons({ nodes: [btn] }); } catch (_) {}
      }
    });
  }

  async function _startPacking(orderId: any) {
    if (window.console && console.time) console.time('[packing] _startPacking total');
    // Check lock state from cache first
    var lock = state.packingLocks[orderId];
    if (lock && !lock.is_mine) {
      showToast('To zamówienie pakuje: ' + lock.user_name, 'error');
      return;
    }
    // Acquire lock
    if (window.console && console.time) console.time('[packing] acquireLock API');
    // Z7 (28.10.2026, runda 2 — właściciel): lock 409 ORDER_CANCELLED = okno otwiera się normalnie, ale jako PODGLĄD:
    // bez blokady (nic do zwolnienia), bez stanu „pakuję” na liście i bez keepalive, od razu z czerwonym paskiem.
    var _podglad = false;
    var _tekstSpakowane = '';  // S-222: 409 PACKED_BY_OTHER → podgląd z paskiem „Spakował już X o HH:MM”
    try {
      await SellBaseAPI.acquirePackingLock(orderId);
    } catch (e: any) {
      var msg = (e && e.message) || '';
      if (_bladAnulowania(e)) {
        _podglad = true;
      } else if (_bladSpakowanePrzezInnego(e)) {
        _podglad = true;
        _tekstSpakowane = String((e.detail && e.detail.message) || msg || KOMUNIKAT_SPAKOWANE);
      } else if (msg.indexOf('pakuje') > -1) {
        showToast(msg, 'error');
        return;
      } else {
        showToast('Nie udało się zablokować zamówienia: ' + msg, 'error');
        return;
      }
    }
    if (window.console && console.timeEnd) console.timeEnd('[packing] acquireLock API');
    // 2026-06-10: nowa sesja pakowania = czysty stan — zdejmij ewentualny
    // wiszacy stealth-gate z poprzedniego (przerwanego) auto-flow.
    document.body.classList.remove('sb-stealth-modal');
    // 2026-06-22 BUGFIX (zwis przy szybkim pakowaniu): nowa sesja pakowania ZAWSZE
    // zwalnia ewentualny ZATRUTY token auto-flow z poprzedniego (przerwanego) przebiegu.
    // Bez tego guard w _finishFlow (`_activeFlowOrderId !== orderId`) po cichu ubijał
    // auto-flow KAŻDEGO kolejnego zamówienia aż do odświeżenia strony (F5).
    _activeFlowOrderId = null;
    state.packingDrawerOpen = true;
    state.packingOrderId = orderId;
    state.packingPodglad = _podglad;
    if (!_podglad) state.packingLocks[orderId] = { user_name: 'Ty', is_mine: true };
    var drawer = document.getElementById('packing-drawer');
    if (drawer) {
      drawer.classList.add('open');
      // Review serii: delegat systemu braków (shortage-report.ts) ustala
      // zamówienie przez closest('[data-order-id]') — bez tego atrybutu
      // „BRAK W MAGAZYNIE" w modalu był martwy.
      drawer.setAttribute('data-order-id', String(orderId));
    }
    // 19.10.2026: miejsce na liście sprzed „Spakuj” — wracamy tu po zakończeniu/anulowaniu pakowania
    _przewiniecieSprzedPakowania = zapamietajWidok(document.getElementById('orders-list-container'));
    // Sprint 20.12 (a11y): focus trap dla packing drawer
    if (drawer && (window as any).__sbFocusTrap && !(drawer as any)._sbTrap) {
      try {
        // DECYZJA usera: zamknięcie tylko przez Anuluj — Esc idzie tą samą
        // ścieżką (potwierdzenie przy zebranych pozycjach).
        var _closeFn = function() { _pmRequestCancel(); };
        (drawer as any)._sbTrap = (window as any).__sbFocusTrap.createFocusTrap(drawer, _closeFn);
        (drawer as any)._sbTrap.activate();
      } catch (_) {}
    }
    // Packing mode: overlay + highlight card + block scroll
    document.body.classList.add('packing-mode'); document.documentElement.classList.add('packing-mode-html');
    var activeCard = document.querySelector('.order-card[data-order-id="' + orderId + '"]');
    if (activeCard) {
      activeCard.classList.add('packing-active');
      _pokazKarteBezSkoku(activeCard);
    }
    // 2026-07-08: nowa sesja pakowania = czysta flaga przycisku etykiety
    delete _labelDoneByButton[orderId];
    _pmWyczyscAnulowane(orderId);  // Z7
    // 2026-07-10: przycisk ZAWSZE renderowany; stan (Generuj vs Drukuj-już-istnieje) z backendu.
    // Renderuj od razu z domyślnym tekstem (żeby był natychmiast), potem doprecyzuj po fetchu.
    if (state.packingOrderId === orderId) _renderGenLabelButton(orderId, false);
    _renderPoprzednieOkienko();
    _fetchLabelState(orderId).then(function(st2: any) {
      if (state.packingOrderId === orderId) _renderGenLabelButton(orderId, !!(st2 && st2.has_label));
    });
    if (window.console && console.time) console.time('[packing] _renderPackingContent + _updatePackingButtons');
    _renderPackingContent(orderId);
    _updatePackingButtons();
    // Z7: świeży status przy otwarciu (okno rysuje się z pamięci listy); podgląd anulowanego — pasek od razu
    if (_podglad) { if (_tekstSpakowane) _pmOznaczSpakowane(orderId, _tekstSpakowane); else _pmOznaczAnulowane(orderId); }
    else _pmSprawdzAnulowane(orderId);
    if (window.console && console.timeEnd) console.timeEnd('[packing] _renderPackingContent + _updatePackingButtons');
    if (window.console && console.timeEnd) console.timeEnd('[packing] _startPacking total');
  }

  // ═══════════════════════════════════════════════════════════════════
  // MODAL PAKOWANIA 2.0 (spec design_handoff 2026-08-24)
  // Stan sesji per otwarcie modala — pozycje (confirmed, imgIdx), komentarze
  // produktów i galerie. ZERUJE się przy każdym zamknięciu (anuluj/wyślij).
  // ═══════════════════════════════════════════════════════════════════
  var _pmSession: any = null;

  function _pmResetSession() { _pmSession = null; (window as any).__sbPakujOknoPrzewoznika = null; }

  function _pmTok(): string {
    var w = window as any;
    return (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken())
      || localStorage.getItem('sellbase_token') || '';
  }

  // Odmiana liczebnika: 1 spakowana / 2-4 spakowane / 0,5+ spakowanych
  function _pmOdmiana(n: number): string {
    if (n === 1) return 'spakowana';
    var m = n % 10, h = n % 100;
    if ((m === 2 || m === 3 || m === 4) && !(h >= 12 && h <= 14)) return 'spakowane';
    return 'spakowanych';
  }

  // E5 §5.6: jedyny żywy tłumacz w domu to `window.__sbI18n.t`. Reszta modala
  // pakowania jest po polsku od serii #3 — zmiana addytywna (§10 „ekran pracuje
  // na produkcji"), więc przez klucze idą WYŁĄCZNIE napisy dołożone w E5.
  function _pmT(key: string, fallback: string): string {
    try {
      var fn = (window as any).__sbI18n && (window as any).__sbI18n.t;
      if (typeof fn === 'function') {
        var v = fn(key);
        if (v && v !== key) return String(v);
      }
    } catch (_: any) {}
    return fallback;
  }
  function _pmLm(txt: string, pary: Record<string, string | number>): string {
    var out = txt;
    Object.keys(pary).forEach(function(k) { out = out.split('{' + k + '}').join(String(pary[k])); });
    return out;
  }

  // Lustro `core/services/link_oracle.norm_sku` (E5 §5.3): spacje, `_` i `-`
  // out, wielkość liter bez znaczenia — ta sama tożsamość SKU, co w bazie.
  // EAN normalizacji NIE przechodzi (to cyfry; `-` w EAN-ie nie występuje,
  // a zdejmowanie znaków robiłoby fałszywe trafienia).
  function _pmNsku(v: any): string {
    return String(v == null ? '' : v).replace(/[\s_-]+/g, '').toUpperCase();
  }

  function _pmSafeHttp(u: any): string {
    var raw = String(u || '').trim();
    if (!raw) return '';
    try { var p = new URL(raw, window.location.origin);
      return (p.protocol === 'http:' || p.protocol === 'https:') ? p.href : ''; }
    catch (_e) { return ''; }
  }

  // Zgłoszenie #5: podpis ikonki oferty — Allegro rozpoznane po hoście URL
  // (dotyczy też pozycji ze składu zestawu, które niosą tylko offerUrl).
  function _pmOfertaAllegro(u: any): boolean {
    try { var h = new URL(String(u || '')).hostname.toLowerCase();
      return h === 'allegro.pl' || h.slice(-11) === '.allegro.pl'; }
    catch (_e) { return false; }
  }

  // URL do wnętrza CSS url('...') w atrybucie style: encje HTML dekodują się
  // PRZED parsowaniem CSS (review serii: escapeAttr(') = &#39; wraca jako
  // apostrof i zamyka url()) — koduj procentowo wszystko, co łamie kontekst.
  function _pmCssUrl(u: any): string {
    var safe = _pmSafeHttp(u);
    if (!safe) return '';
    // UWAGA: encodeURIComponent NIE koduje ' ( ) — procentuj ręcznie.
    return safe.replace(/['"()\s\\]/g, function(c) {
      var h = c.charCodeAt(0).toString(16).toUpperCase();
      return '%' + (h.length < 2 ? '0' + h : h);
    });
  }

  // 2026-09-25 (właściciel): źródło zdjęć pozycji = ustawienie FIRMY (admin ustawia, wszyscy widzą tak samo).
  // Odczyt przy każdym otwarciu okna (krótka pamięć podręczna), awaria = ostatnia znana wartość / domyślne.
  var _pmZrodloZdjec: ZrodloZdjec = 'sellbase';
  var _pmZrodloZdjecTs = 0;
  async function _pmWczytajZrodloZdjec(): Promise<ZrodloZdjec> {
    if (Date.now() - _pmZrodloZdjecTs < 120000) return _pmZrodloZdjec;
    try {
      var r = await _fetchWT('/api/packing/settings', { headers: { 'Authorization': 'Bearer ' + _pmTok() } }, 6000);
      if (r.ok) {
        var j = await r.json();
        _pmZrodloZdjec = zrodloZdjecZKonfigu(j && j.config && j.config.image_source);
        _pmZrodloZdjecTs = Date.now();
      }
    } catch (_: any) { /* zostaje ostatnia znana wartość */ }
    return _pmZrodloZdjec;
  }

  // 2026-08-24 (user): link do oferty Allegro MUSI być — offer_url bywa
  // puste dla Allegro, wtedy budujemy kanoniczny https://allegro.pl/oferta/.
  function _pmAdresOferty(order: any, it: any): string {
    var oUrl = _pmSafeHttp(it && it.offer_url);
    if (!oUrl && order.is_allegro && it && it.offer_id) {
      oUrl = 'https://allegro.pl/oferta/' + encodeURIComponent(String(it.offer_id));
    }
    return oUrl;
  }

  // Zgłoszenie #5 (28.10): pozycja ze składu katalogowego nie niesie oferty — tytuł i adres
  // bierzemy z dopasowanej pozycji zamówienia (to samo dopasowanie co zdjęcie oferty).
  // Zestaw SellBase zostaje podpisany drugą linijką pod tytułem oferty.
  function _pmOfertaPozycjiKatalogu(order: any, p: any): void {
    if (p.offerUrl || p.komponent) return;
    var it = pozycjaZamowieniaDlaPozycji(order, p);
    var url = it ? _pmAdresOferty(order, it) : '';
    var offerId = String(p.offerId || '');
    if (!url && order.is_allegro && /^\d+$/.test(offerId)) url = 'https://allegro.pl/oferta/' + offerId;
    p.offerUrl = url;
    var tytul = it ? String(it.name || '').trim() : '';
    if (tytul) {
      if (p.soldKind === 'bundle') p.offerNote = String(p.offerName || '').replace(/^\S+ × /, '');
      p.offerName = tytul;
    }
  }

  // Spłaszczenie zamówienia do listy pozycji do zebrania:
  // item × każdy powiązany produkt SellBase; item bez powiązania = pozycja
  // z danych oferty (bez komentarzy — nie ma product_id).
  function _pmBuildPositions(order: any): any[] {
    var items = Array.isArray(order.items) ? order.items : [];
    var out: any[] = [];
    items.forEach(function(it: any, itIdx: number) {
      var qty = parseInt(String(it.quantity || 1), 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var oUrl = _pmAdresOferty(order, it);
      // Kody OFERTY z marketplace'u — celowo OSOBNO od kodów magazynowych
      // produktu (pułapka ze spec: nie podstawiać jednych za drugie).
      var oSku = String(it.sku || it.product_reference || it.seller_sku || '');
      var oEan = String(it.ean || '');
      var sbProducts = Array.isArray(it.sellbase_products) ? it.sellbase_products : [];
      if (sbProducts.length === 0 && it.sellbase_product_id) {
        sbProducts = [{
          id: it.sellbase_product_id,
          name: it.sellbase_product_name || it.name,
          sku: it.sellbase_sku || '',
          ean: it.sellbase_ean || '',
          eany_dodatkowe: Array.isArray(it.sellbase_eany_dodatkowe) ? it.sellbase_eany_dodatkowe : [],
          image_url: it.sellbase_image_url || '',
          location: it.sellbase_location || '',
          link_quantity: parseInt(it.sellbase_link_quantity) || 1,
          zestaw: Array.isArray(it.sellbase_zestaw) ? it.sellbase_zestaw : [],
          komponenty: Array.isArray(it.sellbase_komponenty) ? it.sellbase_komponenty : [],
        }];
      }
      if (sbProducts.length > 0) {
        sbProducts.forEach(function(prod: any, pIdx: number) {
          var linkQty = parseInt(String(prod.link_quantity || 1), 10) || 1;
          // 2026-10-01 (właściciel): zestaw rozbity na składniki (każdy ze swoim SKU/EAN/lokalizacją)
          // + komponenty (taśma, śrubka) do odhaczenia — moduł packing-sklad.ts
          var _klucz = 'p' + itIdx + '_' + pIdx;
          var _oferta = { offerName: String(it.name || ''), offerUrl: oUrl };
          var _sklad = pozycjeZestawu(prod.zestaw, qty * linkQty, _klucz, String(prod.name || it.name || ''), _oferta,
            function(u: string) { return u ? [u] : (it.offer_image_url ? [String(it.offer_image_url)] : []); });
          if (_sklad.length) {
            _sklad.forEach(function(z: any) { out.push(z); });
            pozycjeKomponentow(prod.komponenty, qty * linkQty, _klucz, String(prod.name || it.name || ''), _oferta, String(prod.sku || '')).forEach(function(k: any) { out.push(k); });
            return;
          }
          // 2026-09-25: kolejność zdjęć wg ustawienia firmy (produkt SellBase albo oferta z marketplace)
          var imgs: string[] = ulozZdjeciaPozycji(_pmZrodloZdjec, [prod.image_url], it.offer_image_url);
          out.push({
            key: 'p' + itIdx + '_' + pIdx,
            pid: prod.id || null,
            name: String(prod.name || it.name || ''),
            sku: String(prod.sku || ''),
            ean: String(prod.ean || ''),
            // S-24 (25.09): dodatkowe EAN karty (druga marka, stara rejestracja w GS1) — skan potwierdza pozycję także po nich
            eany: (Array.isArray(prod.eany_dodatkowe) ? prod.eany_dodatkowe : []).map(function(x: any) { return String(x || '').trim(); }).filter(Boolean),
            qty: qty * linkQty,
            location: String(prod.location || ''),
            imgs: imgs, imgIdx: 0, confirmed: false,
            offerName: String(it.name || ''), offerZestaw: it.zestaw_allegro || null,
            offerUrl: oUrl, offerSku: oSku, offerEan: oEan,
          });
          pozycjeKomponentow(prod.komponenty, qty * linkQty, _klucz, String(prod.name || it.name || ''), _oferta, String(prod.sku || '')).forEach(function(k: any) { out.push(k); });
        });
      } else {
        out.push({
          key: 'p' + itIdx + '_x',
          pid: null,
          name: String(it.name || ''),
          sku: String(it.sku || ''),
          ean: String(it.ean || ''),
          qty: qty,
          location: '',
          imgs: it.offer_image_url ? [String(it.offer_image_url)] : [],
          imgIdx: 0, confirmed: false,
          offerName: String(it.name || ''), offerZestaw: it.zestaw_allegro || null,
          offerUrl: oUrl, offerSku: oSku, offerEan: oEan,
        });
      }
    });
    return out;
  }

  function _pmGalleryHtml(pos: any): string {
    var imgs = pos.imgs || [];
    if (!imgs.length) {
      return '<div class="pm-gallery" style="display:flex;align-items:center;justify-content:center">' +
        '<i data-lucide="package" style="width:44px;height:44px;opacity:.3"></i></div>';
    }
    var idx = Math.max(0, Math.min(pos.imgIdx || 0, imgs.length - 1));
    var nav = '';
    var dots = '';
    if (imgs.length > 1) {
      nav = '<button class="pm-gallery-nav pm-gallery-nav--prev" data-pos="' + escapeAttr(pos.key) + '" data-dir="-1" title="Poprzednie zdjęcie"><i data-lucide="chevron-left" style="width:30px;height:30px"></i></button>' +
        '<button class="pm-gallery-nav pm-gallery-nav--next" data-pos="' + escapeAttr(pos.key) + '" data-dir="1" title="Następne zdjęcie"><i data-lucide="chevron-right" style="width:30px;height:30px"></i></button>';
      dots = '<div class="pm-gallery-dots">' + imgs.map(function(_: any, i: number) {
        return '<span class="pm-gallery-dot' + (i === idx ? ' on' : '') + '"></span>';
      }).join('') + '</div>';
    }
    var thumbs = imgs.length > 1
      ? '<div class="pm-thumbs">' + imgs.map(function(u: string, i: number) {
          return '<img class="pm-thumb' + (i === idx ? ' on' : '') + '" data-pos="' + escapeAttr(pos.key) + '" data-idx="' + i + '" src="' + escapeAttr(u) + '" loading="lazy" onerror="this.style.visibility=\'hidden\'">';
        }).join('') + '</div>'
      : '';
    return '<div class="pm-gallery sb-zoom" style="background-image:url(\'' + _pmCssUrl(imgs[idx]) + '\')">' + nav + dots + '</div>' + thumbs;
  }

  function _pmCommentsHtml(pos: any): string {
    // Seria #3 (user): sekcja notatek ZAWSZE zajmuje miejsce — pusty wariant
    // (przerywana, stonowana ramka) trzyma stały layout pozycji, nic nie
    // skacze gdy komentarze dociągną się async po otwarciu.
    var comments = (pos.pid && _pmSession && _pmSession.commentsByPid && _pmSession.commentsByPid[String(pos.pid)]) || [];
    if (!comments.length) {
      return '<div class="pm-note pm-note--empty">' +
        '<div class="pm-note-head"><i data-lucide="sticky-note" style="width:11px;height:11px"></i> Notatki produktu</div>' +
        '<div class="pm-note-empty-txt">Brak notatek</div>' +
      '</div>';
    }
    var rows = comments.slice(0, 3).map(function(c: any) {
      var content = String(c.content || '').trim();
      if (content.length > 220) content = content.slice(0, 220) + '…';
      var imgs = Array.isArray(c.images) ? c.images : [];
      var imgsHtml = imgs.slice(0, 4).map(function(url: any) {
        // Review serii (KRYT): URL z product_comments to dane usera — do inline
        // onclick NIE wolno go kleić (escapeAttr nie chroni kontekstu JS-stringa).
        // Otwarcie obsługuje delegat w _pmBindDelegates po data-full (safeHttp).
        var safeUrl = _pmSafeHttp(url);
        if (!safeUrl) return '';
        safeUrl = adresPlikuPrywatnego(safeUrl);  // FIL-001: zdjęcia notatek prywatne — token medialny
        return '<img class="sb-thumb sb-zoom pm-note-img" src="' + escapeAttr(safeUrl) + '" data-full="' + escapeAttr(safeUrl) + '" loading="lazy" style="width:34px;height:34px;border-radius:5px;object-fit:cover;cursor:zoom-in">';
      }).join('');
      var author = String(c.author_name || '').slice(0, 30);
      return '<div style="margin-top:5px">' +
        (content ? '<div>' + escapeHtml(content) + '</div>' : '') +
        (imgsHtml ? '<div style="display:flex;gap:4px;margin-top:4px;flex-wrap:wrap">' + imgsHtml + '</div>' : '') +
        (author ? '<div class="pm-note-author">— ' + escapeHtml(author) + '</div>' : '') +
      '</div>';
    }).join('');
    return '<div class="pm-note">' +
      '<div class="pm-note-head"><i data-lucide="sticky-note" style="width:11px;height:11px"></i> Notatki produktu (' + comments.length + ')</div>' +
      rows +
    '</div>';
  }

  // 2026-10-01 (właściciel): rodzaj pozycji w pasku statusu — składnik zestawu / komponent (taśma, śrubka)
  function _pmRodzajPozycji(pos: any): string {
    if (pos.komponent) {
      return 'komponent: włóż do paczki' + (pos.dla ? ' (do: ' + escapeHtml(String(pos.dla)) + ')' : '');
    }
    if (pos.zestaw) {
      return 'składnik zestawu „' + escapeHtml(String(pos.zestaw)) + '”' +
        (pos.skladDzis ? ' · skład z karty (zestaw zdefiniowany po wpłynięciu zamówienia)' : '');
    }
    return 'do zebrania';
  }

  // Przycisk „Zgłoś brak” (wykrzyknik) komponentu — te same klasy i data-shortage-* co przy produkcie (_pmPosHtml).
  // Delegat w shortage-report.ts zbiera wszystkie takie przyciski szuflady (`[data-order-id]`) do jednego okna zgłoszenia.
  function _pmBrakBtnHtml(d: DaneBraku, tytul: string, ikona: number): string {
    return '<button type="button" class="pm-shortage-btn oc-sb-nostock-btn" onclick="event.stopPropagation()" title="' + escapeAttr(tytul) + '"' +
      ' data-shortage-product-id="' + escapeAttr(d.productId) + '"' +
      ' data-shortage-sku="' + escapeAttr(d.sku) + '"' +
      ' data-shortage-name="' + escapeAttr(d.name) + '"' +
      ' data-shortage-qty="' + d.qty + '"' +
      ' data-shortage-img="' + escapeAttr(d.img) + '"' +
      (d.note ? ' data-shortage-note="' + escapeAttr(d.note) + '"' : '') +
      (d.zestawName ? ' data-shortage-zestaw-name="' + escapeAttr(d.zestawName) + '"' : '') + '>' +
      '<i data-lucide="alert-circle" style="width:' + ikona + 'px;height:' + ikona + 'px"></i></button>';
  }

  // 2026-10-01 (właściciel: „komponenty mają być widoczne jako część tego, co ktoś zamówił”) — lista w karcie produktu,
  // każdy komponent odhaczany kliknięciem (bez skanu); obok wykrzyknik „Zgłoś brak” komponentu (właściciel, #118815:
  // „nie można zgłosić braku komponentu, tylko cały produkt”) — osobny przycisk, nie w środku przełącznika.
  function _pmKomponentyListaHtml(dzieci: any[]): string {
    if (!dzieci || !dzieci.length) return '';
    var gotowe = dzieci.filter(function(d: any) { return d.confirmed; }).length;
    return '<div class="pm-komp-lista" style="margin-top:12px;padding:10px 12px;border:1px dashed var(--color-border);border-radius:10px">' +
      '<div style="font-size:11px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;color:var(--pk-t3);margin-bottom:4px">' +
        'W skład wchodzi — włóż do paczki (' + gotowe + ' z ' + dzieci.length + ')</div>' +
      dzieci.map(function(d: any) {
        var img = d.imgs && d.imgs[0]
          ? '<img class="sb-thumb" src="' + escapeAttr(d.imgs[0]) + '" alt="" loading="lazy" style="width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0">'
          : '<span style="width:44px;height:44px;border-radius:8px;background:var(--color-surface-2);display:inline-flex;align-items:center;justify-content:center;flex-shrink:0"><i data-lucide="paperclip" style="width:18px;height:18px;opacity:.45"></i></span>';
        var info = [d.sku ? 'SKU: ' + escapeHtml(d.sku) : '', d.location ? '📍 ' + escapeHtml(d.location) : '', d.opis ? escapeHtml(d.opis) : ''].filter(Boolean).join(' · ');
        var przelacznik = '<button type="button" class="pm-komp-toggle" data-pos="' + escapeAttr(d.key) + '" aria-pressed="' + (d.confirmed ? 'true' : 'false') + '"' +
          ' title="' + (d.confirmed ? 'Włożone — kliknij, aby cofnąć' : 'Kliknij, gdy włożysz do paczki') + '"' +
          ' style="display:flex;align-items:center;gap:10px;flex:1;min-width:0;padding:8px 10px;border-radius:8px;border:1px solid var(--color-border);' +
          'background:' + (d.confirmed ? 'var(--color-surface-2)' : 'var(--color-surface)') + ';color:inherit;text-align:left;cursor:pointer;opacity:' + (d.confirmed ? '.65' : '1') + '">' +
          '<i data-lucide="' + (d.confirmed ? 'check-circle-2' : 'circle') + '" style="width:20px;height:20px;flex-shrink:0;' + (d.confirmed ? 'color:var(--pk-green)' : 'opacity:.5') + '"></i>' +
          '<span class="pm-qty" style="font-size:15px;padding:2px 8px">×' + d.qty + '</span>' + img +
          '<span style="flex:1;min-width:0"><span style="display:block;font-weight:700;font-size:13.5px;overflow-wrap:anywhere;' + (d.confirmed ? 'text-decoration:line-through' : '') + '">' + escapeHtml(d.name) + '</span>' +
            (info ? '<span style="display:block;font-size:11.5px;color:var(--pk-t3);overflow-wrap:anywhere">' + info + '</span>' : '') + '</span>' +
          '<span style="font-size:11px;font-weight:700;white-space:nowrap;color:' + (d.confirmed ? 'var(--pk-green)' : 'var(--pk-t3)') + '">' + (d.confirmed ? 'włożone' : 'włóż') + '</span>' +
        '</button>';
        // dołożony komponent nie ma braku — jak produkt: po potwierdzeniu wykrzyknik znika
        return '<div class="pm-komp-row" style="display:flex;align-items:stretch;gap:6px;margin-top:6px">' + przelacznik +
          (d.confirmed ? '' : _pmBrakBtnHtml(daneBraku(d), 'Zgłoś brak komponentu / do druku', 16)) + '</div>';
      }).join('') + '</div>';
  }

  // Komponenty bez pozycji-rodzica (np. komponenty samego zestawu) — karta „Włóż do paczki”.
  function _pmGrupaKomponentowHtml(g: any, ordinal: number, total: number): string {
    return '<div class="pm-pos" data-pos="' + escapeAttr(g.klucz) + '">' +
      '<div class="pm-pos-statusrow"><span class="pm-pos-dot"></span>' +
        '<span class="pm-pos-status">Pozycja ' + ordinal + ' z ' + total + ' — włóż do paczki: ' + escapeHtml(String(g.tytul || '')) + '</span></div>' +
      _pmKomponentyListaHtml(g.dzieci) +
    '</div>';
  }

  function _pmPosHtml(pos: any, ordinal: number, total: number, dzieci?: any[]): string {
    var loc = pos.location
      ? '<span class="pm-pos-loc"><i data-lucide="map-pin" style="width:13px;height:13px"></i>' + escapeHtml(pos.location) + '</span>'
      : '';
    // Zgłoszenie #5 (28.10, właściciel): tytuł oferty jako zwykły tekst, a zaraz
    // za nim ikonka otwarcia oferty jak przy tytule produktu SellBase. Ostatnie
    // słowo + ikonka w nowrap — przy zawijaniu ikonka nie ucieka do nowej linii.
    var offerName = String(pos.offerName || '');
    var offerLine;
    if (pos.offerUrl) {
      var cut = offerName.search(/\S+\s*$/);
      if (cut < 0) cut = offerName.length;
      var offerTitle = _pmOfertaAllegro(pos.offerUrl) ? 'Otwórz ofertę na Allegro' : 'Otwórz ofertę na marketplace';
      offerLine = '<div class="pm-offer-link">' + zestawAllegroChip(pos.offerZestaw) + escapeHtml(offerName.slice(0, cut)) +
        '<span class="pm-offer-tail">' + escapeHtml(offerName.slice(cut).trim()) +
          '<a class="pm-open-offer" href="' + escapeAttr(pos.offerUrl) + '" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()" title="' + offerTitle + '" aria-label="' + offerTitle + '"><i data-lucide="external-link" style="width:13px;height:13px"></i></a>' +
        '</span></div>';
    } else {
      offerLine = '<div class="pm-offer-link">' + zestawAllegroChip(pos.offerZestaw) + escapeHtml(offerName) + '</div>';
    }
    // S-57 (pkt 10): pakowacz widzi „Wielopak Allegro · 2 × …” przed tytułem oferty
    // Kody oferty pod tytułem — tylko gdy jest powiązany produkt (bez niego
    // chipy niżej pokazują te same kody z pozycji i byłby dubel).
    var offerCodeParts = [];
    if (pos.offerSku) offerCodeParts.push('SKU: ' + escapeHtml(pos.offerSku));
    if (pos.offerEan) offerCodeParts.push('EAN: ' + escapeHtml(pos.offerEan));
    if (pos.offerNote) offerLine += '<div class="pm-offer-codes">' + escapeHtml(pos.offerNote) + '</div>';
    if (pos.pid && offerCodeParts.length) {
      offerLine += '<div class="pm-offer-codes">' + offerCodeParts.join(' · ') + '</div>';
    }
    var chips = '';
    if (pos.sku) chips += '<span class="pm-code-chip">SKU: ' + escapeHtml(pos.sku) + '</span>';
    if (pos.ean) chips += '<span class="pm-code-chip">EAN: ' + escapeHtml(pos.ean) + '</span>';
    // Seria #3 (user): braki = kwadratowy wykrzyknik jak na liście zamówień
    var shortageBtn = pos.pid
      ? '<button class="pm-shortage-btn oc-sb-nostock-btn" onclick="event.stopPropagation()" title="Zgłoś brak / do druku"' +
          ' data-shortage-product-id="' + escapeAttr(String(pos.pid)) + '"' +
          ' data-shortage-sku="' + escapeAttr(pos.sku || pos.offerSku || '') + '"' +
          ' data-shortage-name="' + escapeAttr(pos.name) + '"' +
          ' data-shortage-qty="' + pos.qty + '"' +
          ' data-shortage-img="' + escapeAttr((pos.imgs && pos.imgs[0]) || '') + '"' +
          // 2026-10-01: składnik zestawu podpisany w oknie zgłoszenia (do czego należy)
          (pos.zestaw ? ' data-shortage-note="' + escapeAttr(daneBraku(pos).note) + '"' : '') +
          (pos.zestaw && !pos.komponent ? ' data-shortage-zestaw-name="' + escapeAttr(String(pos.zestaw)) + '"' : '') + '>' +
          '<i data-lucide="alert-circle" style="width:18px;height:18px"></i></button>'
      : '';
    return '<div class="pm-pos" data-pos="' + escapeAttr(pos.key) + '">' +
      '<div class="pm-pos-statusrow">' +
        '<span class="pm-pos-dot"></span>' +
        '<span class="pm-pos-status">Pozycja ' + ordinal + ' z ' + total + ' — ' +
          (pos.confirmed ? 'produkt zebrany, włóż komponenty' : _pmRodzajPozycji(pos)) + '</span>' +
        loc +
      '</div>' +
      // S-160 (MOB-2): klasa układu — na telefonie galeria nad opisem (mobile.css).
      '<div class="pm-pos-uklad" style="display:flex;gap:16px;align-items:flex-start">' +
        '<div class="pm-gal-wrap" data-pos="' + escapeAttr(pos.key) + '" style="flex-shrink:0">' + _pmGalleryHtml(pos) + '</div>' +
        '<div style="flex:1;min-width:0">' +
          offerLine +
          '<div class="pm-prod-row">' +
            '<span class="pm-qty">×' + pos.qty + '</span>' +
            '<div class="pm-prod-title">' + escapeHtml(pos.name) +
              // Seria #3 (user): ikonka otwarcia drawera produktu SellBase
              (pos.pid ? ' <button class="pm-open-product" data-product-id="' + escapeAttr(String(pos.pid)) + '" title="Otwórz produkt SellBase"><i data-lucide="external-link" style="width:15px;height:15px"></i></button>' : '') +
            '</div>' +
          '</div>' +
          (chips ? '<div>' + chips + '</div>' : '') +
          (pos.komponent && pos.opis ? '<div class="pm-offer-codes" style="white-space:pre-wrap">' + escapeHtml(pos.opis) + '</div>' : '') +
          (pos.komponent ? '' : _pmCommentsHtml(pos)) +
          _pmKomponentyListaHtml(dzieci || []) +
          // Seria #3 (user): trzy akcje w JEDNEJ linii —
          // [POTWIERDZAM][ZESKANUJ EAN — zapowiedź, logika w _pmScan][wykrzyknik]
          '<div class="pm-pos-actions">' +
            (pos.confirmed
              ? '<button class="pm-restore-btn" data-pos="' + escapeAttr(pos.key) + '" title="Przywróć produkt do zbierania"><i data-lucide="check-circle-2" style="width:15px;height:15px"></i> Produkt zebrany — przywróć</button>'
              : '<button class="pm-confirm-btn" data-pos="' + escapeAttr(pos.key) + '"><i data-lucide="check" style="width:15px;height:15px"></i> POTWIERDZAM</button>') +
            (pos.komponent || pos.confirmed ? '' :
            '<button class="pm-scanean-btn" data-pos="' + escapeAttr(pos.key) + '">' +
              '<i data-lucide="scan-barcode" style="width:17px;height:17px"></i> ZESKANUJ EAN' +
            '</button>' +
            shortageBtn) +
          '</div>' +
          // E5 §5.4 (rekomendacja §9.4 — „włączyć"): pole skanu miało gotowy CSS
          // (`style.css` .pm-scan) i podpięty `Enter` w `_pmBindDelegates` od serii #3,
          // ale ŻADEN markup go nie wystawiał — chip w toaście i wybór przy wielu
          // trafieniach byłyby martwym kodem. `inputmode="none"` = skaner pisze jak
          // klawiatura, a na tablecie nie wyskakuje klawiatura ekranowa i nie zasłania listy.
          (pos.komponent || pos.confirmed ? '' :
          '<div class="pm-scan-row">' +
            '<input class="pm-scan" data-pos="' + escapeAttr(pos.key) + '" autocomplete="off" inputmode="none"' +
              ' placeholder="' + escapeAttr(_pmT('packing.scan_placeholder', 'Zeskanuj SKU lub EAN')) + '"' +
              ' aria-label="' + escapeAttr(_pmT('packing.scan_placeholder', 'Zeskanuj SKU lub EAN')) + '">' +
          '</div>') +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // Mini-galeria nie jest szersza niż główne zdjęcie — przewija się w bok,
  // a aktywna miniatura jest dosuwana do środka (user 2026-08-24).
  function _pmCenterThumbs(root: any) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.pm-thumbs').forEach(function(tw: any) {
      var on = tw.querySelector('.pm-thumb.on');
      if (!on) return;
      tw.scrollLeft = Math.max(0, on.offsetLeft - (tw.clientWidth - on.offsetWidth) / 2);
    });
  }

  function _pmRenderLeft() {
    var body = document.getElementById('packing-drawer-body');
    if (!body || !_pmSession) return;
    var list = _pmSession.positions;
    // 2026-10-01 (właściciel): komponenty są częścią zamówionego produktu — karta grupy (produkt + jego
    // komponenty) zostaje, dopóki produkt i wszystkie komponenty nie są potwierdzone.
    var grupy = grupujPozycje(list);
    var pending = grupy.filter(function(g: any) { return !grupaGotowa(g); });
    // 2026-09-25 (właściciel, #116823): przy kilku pozycjach kafelki zajmowały cały ekran — tryb
    // kompaktowy (mniejsza galeria, bez pustej ramki notatek, ciaśniejsze akcje); zdjęcie, tytuł
    // i ilość zostają duże. Stały przez całą sesję (nie skacze, gdy zostaje ostatnia pozycja).
    body.classList.toggle('pm-left--compact', list.length > 1);
    var html = '';
    if (!list.length) {
      html = '<div style="padding:40px;text-align:center;color:var(--pk-t3)">Brak pozycji w zamówieniu</div>';
    } else if (!pending.length) {
      html = '<div class="pm-all-done"><i data-lucide="check-circle" style="width:40px;height:40px"></i>' +
        'Wszystkie pozycje zebrane — możesz wysłać</div>';
    } else {
      pending.forEach(function(g: any) {
        var ordinal = grupy.indexOf(g) + 1;
        html += g.glowna ? _pmPosHtml(g.glowna, ordinal, grupy.length, g.dzieci) : _pmGrupaKomponentowHtml(g, ordinal, grupy.length);
      });
    }
    body.innerHTML = html;
    if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [body] }); } catch (_: any) {} }
    _pmCenterThumbs(body);
  }

  function _pmRenderSide() {
    var side = document.getElementById('pm-side');
    if (!side || !_pmSession) return;
    var order = _pmSession.order;
    var list = _pmSession.positions;
    var _grupy = grupujPozycje(list);
    var done = licznikGrup(_grupy).gotowe;
    var _wszystkie = _grupy.length;
    // 2026-10-01: komponenty wcięte pod swoim produktem (część zamówionego produktu, nie osobne pozycje)
    var _uloz: any[] = [];
    _grupy.forEach(function(g: any) {
      if (g.glowna) _uloz.push(g.glowna);
      else _uloz.push({ naglowekGrupy: true, name: 'Włóż do paczki: ' + String(g.tytul || '') });
      g.dzieci.forEach(function(d: any) { _uloz.push(d); });
    });

    // STATUS POZYCJI
    var statusRows = _uloz.map(function(p: any) {
      if (p.naglowekGrupy) {
        return '<div class="pm-status-item" style="font-weight:700">' + escapeHtml(p.name) + '</div>';
      }
      var _wciecie = p.komponent ? ' style="margin-left:22px;font-size:11.5px"' : '';
      // Seria #3 (user): ilość w SZARYM labelu (chip jak przy ofertach na liście)
      var qtyChip = '<span class="zk-offer-qty" style="flex-shrink:0">x' + p.qty + '</span>';
      // E5 §5.1: 184 grupy / 395 produktów mają IDENTYCZNE nazwy (USTALENIA §4),
      // więc sama nazwa w liście statusu nie odróżnia towaru. Chip jest CZYSTO
      // WIZUALNY (niczego nie potwierdza), dlatego fallback na kod OFERTY jest
      // tu dopuszczalny — w skanie ta sama zamiana jest ZAKAZANA (§5.3 i komentarz
      // przy `_pmBuildPositions`: „nie podstawiać jednych za drugie"). Kod oferty
      // dostaje przygaszoną klasę, żeby magazynier widział, że to nie kod magazynowy.
      var skuTxt = p.komponent ? 'komponent' : String(p.sku || '');
      var skuZOferty = !skuTxt && !!p.offerSku;
      if (skuZOferty) skuTxt = String(p.offerSku);
      var skuChip = skuTxt
        ? '<span class="pm-status-sku' + (skuZOferty ? ' pm-status-sku--oferta' : '') + '" title="' + escapeAttr(skuTxt) + '">' + escapeHtml(skuTxt) + '</span>'
        : '';
      if (p.confirmed) {
        return '<div class="pm-status-item pm-status-item--done" data-pos="' + escapeAttr(p.key) + '" title="Kliknij, aby przywrócić pozycję do zbierania"' + _wciecie + '>' +
          '<i data-lucide="check-circle-2" style="width:14px;height:14px;color:var(--pk-green);flex-shrink:0"></i>' +
          qtyChip + skuChip +
          '<span class="pm-status-name">' + escapeHtml(p.name) + '</span>' +
          '<button class="pm-restore-btn" data-pos="' + escapeAttr(p.key) + '">Przywróć</button>' +
        '</div>';
      }
      return '<div class="pm-status-item"' + _wciecie + '>' +
        '<i data-lucide="circle" style="width:14px;height:14px;opacity:.4;flex-shrink:0"></i>' +
        qtyChip + skuChip +
        '<span class="pm-status-name">' + escapeHtml(p.name) + '</span>' +
      '</div>';
    }).join('');

    // Dane zamówienia (prawa kolumna — spec: KUPUJĄCY/WIADOMOŚĆ/DOSTAWA/OFERTY/ZAMÓWIENIE)
    var buyerMsg = String(order.message_to_seller || order.buyer_message || '').trim();
    var addr = order.shippingAddress || {};
    var deliveryMethod = order.delivery ? (order.delivery.method || '') : '';
    var deliveryAddrParts = [];
    if (addr.street) deliveryAddrParts.push(addr.street);
    var deliveryPostCity = [(addr.postal_code || ''), (addr.city || '')].filter(Boolean).join(' ');
    if (deliveryPostCity) deliveryAddrParts.push(deliveryPostCity);
    var pickup = order.delivery && order.delivery.pickup_point;
    if (pickup && pickup.id) deliveryAddrParts.push('📦 ' + String(pickup.id));
    var _delCost = order.deliveryCostAmount || 0;
    var deliveryChip = _delCost > 0
      ? '<span class="zk-money-chip">' + SellBaseData.formatCurrency(_delCost, order.currency) + '</span>'
      : (order.is_allegro
          ? '<span class="zk-money-chip zk-money-chip--smart">SMART</span>'
          : '<span class="zk-money-chip zk-money-chip--free">' + SellBaseData.formatCurrency(0, order.currency) + '</span>');

    // Review serii: re-render side (confirm/restore/fetchExtras) NIE może zjadać
    // pisanej notatki — snapshot żywej wartości + fokus/selekcja przed innerHTML.
    var _liveTa = side.querySelector('.pm-order-note') as HTMLTextAreaElement | null;
    var _liveVal: string | null = _liveTa ? _liveTa.value : null;
    var _hadFocus = !!(_liveTa && document.activeElement === _liveTa);
    var _selS = _liveTa ? _liveTa.selectionStart : 0;
    var _selE = _liveTa ? _liveTa.selectionEnd : 0;
    var noteVal = _liveVal !== null ? _liveVal : String(_pmSession.noteBaseline || '');
    var fmtTel = (window as any).__sbExports && (window as any).__sbExports.formatujTelefon;
    var phone = String(order.customerPhone || order.phone || '');

    side.innerHTML =
      '<div class="pm-side-hdr">Status pozycji <span style="font-weight:700;color:var(--pk-t3);text-transform:none;letter-spacing:0">' + done + ' z ' + _wszystkie + ' ' + _pmOdmiana(done) + '</span></div>' +
      '<div class="pm-side-hint">Kliknij zebraną pozycję, aby przywrócić ją do zbierania.</div>' +
      statusRows +
      '<div class="pm-side-hdr">Notatka do zamówienia <span id="pm-note-saved-slot"></span></div>' +
      '<textarea class="pm-order-note" placeholder="Wewnętrzna notatka — zapisuje się po wyjściu z pola">' + escapeHtml(noteVal) + '</textarea>' +
      '<div class="pm-side-hdr">Kupujący</div>' +
      (order.customer ? '<div style="font-size:12px;font-weight:700;color:var(--pk-t1)">' + escapeHtml(order.customer) + '</div>' : '') +
      (phone ? '<div style="font-size:11.5px;color:var(--pk-t3);margin-top:2px">' + escapeHtml(typeof fmtTel === 'function' ? fmtTel(phone) : phone) + '</div>' : '') +
      (order.buyer_login ? '<div style="font-size:11.5px;color:var(--pk-t3);margin-top:2px">' + escapeHtml(order.buyer_login) + '</div>' : '') +
      (buyerMsg
        ? '<div class="pm-side-hdr">Wiadomość od kupującego</div><div class="zk-msg-body" style="margin-top:0">' + escapeHtml(buyerMsg) + '</div>'
        : '') +
      '<div class="pm-side-hdr">Dostawa ' + deliveryChip + '</div>' +
      // 2026-08-27 (zgłoszenie usera): podgląd sposobu wysyłki + zmiana jak
      // w drawerze — ołówek otwiera wspólny modal „Zmień sposób wysyłki"
      // (bind niżej po renderze; chunk orders-detail dociągany leniwie).
      '<div style="font-size:12px;font-weight:700;color:var(--pk-t1);display:flex;align-items:center;gap:5px">' +
        '<span>' + escapeHtml(deliveryMethod || 'Sposób wysyłki nieustawiony') + '</span>' +
        '<button type="button" class="od-delivery-method-edit" title="Zmień sposób wysyłki"' +
          ' style="border:0;background:transparent;cursor:pointer;color:var(--pk-t3);opacity:.75;padding:1px 2px;line-height:0">' +
          '<i data-lucide="pencil" style="width:12px;height:12px"></i></button>' +
      '</div>' +
      (deliveryAddrParts.length ? '<div style="font-size:11.5px;color:var(--pk-t3);margin-top:3px;line-height:1.45">' + deliveryAddrParts.map(escapeHtml).join('<br>') + '</div>' : '') +
      // Seria #2 (user): bez powtarzania tytułów — czyste podsumowanie kwot.
      '<div class="pm-side-hdr">Produkty <span class="zk-money-chip">' + SellBaseData.formatCurrency(order.amount - _delCost, order.currency) + '</span></div>' +
      '<div class="zk-order-total-row"><span class="zk-order-total-label">ZAMÓWIENIE</span>' +
        '<span class="zk-order-total">' + SellBaseData.formatCurrency(order.amount, order.currency) + '</span></div>';
    if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [side] }); } catch (_: any) {} }
    // Bind ołówka metody wysyłki (helper żyje w chunku orders-detail — na
    // zimnym wejściu w pakowanie dociągamy go leniwie, jak drawer PS).
    try {
      var _wPen: any = window as any;
      var _bindPen = (_wPen.__sbExports && _wPen.__sbExports.bindDeliveryMethodPencils) || _wPen.bindDeliveryMethodPencils;
      if (typeof _bindPen === 'function') _bindPen(order);
      else import('./orders-detail.js').then(function () {
        var f = (_wPen.__sbExports && _wPen.__sbExports.bindDeliveryMethodPencils) || _wPen.bindDeliveryMethodPencils;
        if (typeof f === 'function') f(order);
      }).catch(function () {});
    } catch (_ePen) { /* ołówek to dodatek */ }
    if (_hadFocus) {
      try {
        var _newTa = side.querySelector('.pm-order-note') as HTMLTextAreaElement | null;
        if (_newTa) { _newTa.focus(); _newTa.setSelectionRange(_selS || 0, _selE || 0); }
      } catch (_: any) {}
    }
  }

  function _pmUpdateProgress() {
    if (!_pmSession) return;
    var list = _pmSession.positions;
    var done = list.filter(function(p: any) { return p.confirmed; }).length;
    var _lg = licznikGrup(grupujPozycje(list));
    var txt = document.getElementById('pm-progress-txt');
    var bar = document.getElementById('pm-progress-bar');
    if (txt) txt.textContent = _lg.wszystkie ? (_lg.gotowe + ' z ' + _lg.wszystkie + ' ' + _pmOdmiana(_lg.gotowe)) : '';
    if (bar) (bar as any).style.width = (list.length ? Math.round(done / list.length * 100) : 0) + '%';
    // DECYZJA usera: „Spakowane — wyślij" ZAWSZE aktywne; przy niepełnym zebraniu
    // stonowany wygląd + potwierdzenie w _completePacking (nie disabled).
    var shipBtn = document.getElementById('packing-complete-btn');
    if (shipBtn) shipBtn.classList.toggle('pm-ship-btn--partial', list.length > 0 && done < list.length);
  }

  function _pmRenderAll() {
    _pmRenderLeft();
    _pmRenderSide();
    _pmUpdateProgress();
  }

  function _pmFindPos(key: any): any {
    if (!_pmSession) return null;
    for (var i = 0; i < _pmSession.positions.length; i++) {
      if (_pmSession.positions[i].key === key) return _pmSession.positions[i];
    }
    return null;
  }

  function _pmConfirm(key: any) {
    var pos = _pmFindPos(key);
    if (!pos || pos.confirmed) return;
    pos.confirmed = true;
    _pmRenderAll();
    // Fokus na pole skanu następnej pozycji — pakowacz skanuje seryjnie.
    try {
      var next = document.querySelector('#packing-drawer-body .pm-scan') as HTMLInputElement | null;
      if (next) next.focus();
    } catch (_: any) {}
  }

  function _pmRestore(key: any) {
    var pos = _pmFindPos(key);
    if (!pos || !pos.confirmed) return;
    pos.confirmed = false;
    _pmRenderAll();
  }

  // E5 §5.2: potwierdzenie ZE SKANU niesie kod w toaście („<SKU> — <nazwa>"),
  // bo przy identycznych nazwach sama nazwa nie mówi, co się właśnie zeszło.
  // Klik ręczny (`_pmConfirm` z przycisku POTWIERDZAM) zostaje BEZ toasta.
  function _pmScanPotwierdz(key: any) {
    var pos = _pmFindPos(key);
    if (!pos || pos.confirmed) return;
    var sku = String(pos.sku || '');
    // Separator wchodzi z kodem, żeby brak SKU nie zostawiał wiszącej pauzy.
    showToast(_pmLm(_pmT('packing.scan_confirmed', 'Pozycja potwierdzona: {sku}{name}'),
      { sku: sku ? sku + ' — ' : '', name: String(pos.name || '') }), 'success');
    _pmConfirm(key);
  }

  /** Zamknięcie panelu wyboru skanu; `refokus` wraca do pola, przy którym stał. */
  function _pmScanZamknijWybor(refokus?: boolean) {
    var box = document.querySelector('#packing-drawer-body .pm-scan-choice');
    if (!box) return;
    var row = box.previousElementSibling;
    box.parentNode && box.parentNode.removeChild(box);
    if (refokus && row) {
      var inp = row.querySelector('.pm-scan') as HTMLInputElement | null;
      if (inp) { try { inp.focus(); inp.select(); } catch (_: any) {} }
    }
  }

  /**
   * Panel wyboru pozycji pod polem skanu (E5 §5.3). Świadomie NIE modal:
   * modal kradnie fokus i zwalnia serię, a `showConfirm` podmienia treść
   * `#modal-body` — czyli zamknąłby modal pakowania (pułapka E3, §10).
   * `zrodlo` mówi, PO CZYM trafiło: kody produktu vs kody oferty.
   */
  function _pmScanWybor(inp: HTMLInputElement, traf: any[], zrodlo: 'produkt' | 'oferta') {
    var row = inp.closest ? (inp.closest('.pm-scan-row') as HTMLElement | null) : null;
    if (!row) return;
    _pmScanZamknijWybor();
    var own = inp.getAttribute('data-pos');
    // Kolejność: pozycja, przy której stoi pole, na górze; reszta po `key`
    // (stabilnie — bez tego przy dwóch trafieniach wybór skakałby po renderach).
    var lista = traf.slice().sort(function(a: any, b: any) {
      var ra = (a.key === own ? 0 : 1), rb = (b.key === own ? 0 : 1);
      return ra !== rb ? ra - rb : String(a.key).localeCompare(String(b.key));
    }).slice(0, 9);
    var opis = zrodlo === 'oferta'
      ? _pmT('packing.scan_hit_offer', 'po kodzie oferty')
      : _pmT('packing.scan_hit_product', 'po kodzie produktu');
    var wiersze = lista.map(function(p: any, i: number) {
      var kod = zrodlo === 'oferta'
        ? String(p.offerSku || p.offerEan || '')
        : String(p.sku || p.ean || '');
      return '<button type="button" class="pm-scan-choice-row" data-pos="' + escapeAttr(p.key) + '">' +
        '<span class="pm-scan-choice-n">' + (i + 1) + '</span>' +
        '<span class="zk-offer-qty" style="flex-shrink:0">x' + p.qty + '</span>' +
        (kod ? '<span class="pm-scan-choice-sku">' + escapeHtml(kod) + '</span>' : '') +
        '<span class="pm-scan-choice-nm">' + escapeHtml(String(p.name || '')) + '</span>' +
        '<span class="pm-scan-choice-src">' + escapeHtml(opis + (p.dla ? ' · komponent do: ' + String(p.dla) : '')) + '</span>' +
      '</button>';
    }).join('');
    row.insertAdjacentHTML('afterend',
      '<div class="pm-scan-choice">' +
        '<div class="pm-scan-choice-t">' + escapeHtml(_pmT('packing.scan_choice_title', 'Która pozycja? Kliknij albo wciśnij cyfrę')) + '</div>' +
        wiersze +
      '</div>');
    var box = row.nextElementSibling as HTMLElement | null;
    if (!box || !box.classList.contains('pm-scan-choice')) return;
    box.addEventListener('click', function(e: any) {
      var b = e.target && e.target.closest && e.target.closest('.pm-scan-choice-row[data-pos]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var key = b.getAttribute('data-pos');
      _pmScanZamknijWybor();
      _pmScanPotwierdz(key);
    });
    box.addEventListener('keydown', function(e: any) {
      // [RECENZJA E5] Skaner pisze jak klawiatura i KOŃCZY ENTEREM. Gdyby fokus stał na
      // wierszu wyboru (to `<button>`), drugi skan nad otwartym panelem — naturalny odruch
      // pakowacza, gdy „nic się nie stało" — aktywowałby wiersz nr 1, czyli potwierdził
      // NIE TĘ pozycję. Enter w panelu nie robi więc nic; wybór to klik albo cyfra.
      if (String(e.key || '') === 'Enter') { e.preventDefault(); return; }
      var n = parseInt(String(e.key || ''), 10);
      if (!(n >= 1 && n <= 9)) return;
      var rows = box!.querySelectorAll('.pm-scan-choice-row');
      if (!rows[n - 1]) return;
      e.preventDefault();
      (rows[n - 1] as HTMLElement).click();
    });
    // Fokus ZOSTAJE w polu skanu (nie na wierszu): kolejny skan trafia tam, gdzie pakowacz
    // się go spodziewa, a cyfrę 1-9 łapie delegat pola (niżej). Panel obsługuje się klikiem
    // albo cyfrą — nigdy Enterem.
    try { inp.value = ''; inp.focus(); } catch (_: any) {}
  }

  /** Cyfra 1-9 w polu skanu przy OTWARTYM panelu wyboru = wybór wiersza (fokus został w polu). */
  function _pmScanCyfraWyboru(e: KeyboardEvent): boolean {
    var box = document.querySelector('#packing-drawer-body .pm-scan-choice') as HTMLElement | null;
    if (!box) return false;
    var n = parseInt(String((e as any).key || ''), 10);
    if (!(n >= 1 && n <= 9)) return false;
    var rows = box.querySelectorAll('.pm-scan-choice-row');
    if (!rows[n - 1]) return false;
    e.preventDefault();
    (rows[n - 1] as HTMLElement).click();
    return true;
  }

  function _pmScan(inp: HTMLInputElement) {
    if (!_pmSession) return;
    var kod = String(inp.value || '').trim();
    if (!kod) return;
    _pmScanZamknijWybor();
    var pending = _pmSession.positions.filter(function(p: any) { return !p.confirmed; });
    var nk = _pmNsku(kod);
    // PASS 1 — SKU PRODUKTU ma pierwszeństwo: gdy trafia, EAN-u już nie pytamy
    // (ten sam EAN bywa u kilku pozycji, SKU jest tożsamością — USTALENIA dec. 1).
    // [RECENZJA E5] `p.pid` obowiązkowe: pozycja bez powiązanego produktu ma w `sku`/`ean`
    // kody Z OFERTY (`_pmBuildPositions`), a te NIE MOGĄ potwierdzać same — idą do PASS 3.
    var poSku = pending.filter(function(p: any) { return p.pid && p.sku && _pmNsku(p.sku) === nk; });
    // PASS 2 — EAN produktu, porównanie SUROWE po `trim` (patrz `_pmNsku`).
    var poEan = poSku.length ? [] : pending.filter(function(p: any) { return p.pid && ((p.ean && String(p.ean).trim() === kod) || (Array.isArray(p.eany) && p.eany.indexOf(kod) >= 0)); });
    if (poSku.length || poEan.length) {
      // KODY PRODUKTU — mogą potwierdzić same; przy kilku trafieniach wybiera
      // człowiek (dziś brało „pierwszą z brzegu" po `pending.sort`, czyli losową).
      var traf = poSku.length ? poSku : poEan;
      if (traf.length === 1) { _pmScanPotwierdz(traf[0].key); return; }
      _pmScanWybor(inp, traf, 'produkt');
      return;
    }
    // PASS 3 — KODY OFERTY (§5.3, §11 poz. 10): NIGDY nie potwierdzają same,
    // nawet przy dokładnie jednym trafieniu. Komentarz przy `_pmBuildPositions`
    // („nie podstawiać jednych za drugie") zostaje w mocy: kod z etykiety
    // marketplace'u może opisywać INNY fizyczny towar niż ten w ręku, więc
    // wynik idzie do panelu wyboru z adnotacją „po kodzie oferty".
    var poOferty = pending.filter(function(p: any) {
      return (p.offerSku && _pmNsku(p.offerSku) === nk) || (p.offerEan && String(p.offerEan).trim() === kod);
    });
    if (poOferty.length) { _pmScanWybor(inp, poOferty, 'oferta'); return; }
    showToast(_pmLm(_pmT('packing.scan_no_match', 'Kod „{kod}" nie pasuje do żadnej niezebranej pozycji'), { kod: kod }), 'error');
    try { inp.select(); } catch (_: any) {}
  }

  // Notatka do zamówienia — zapis TRWAŁY on-blur, tylko przy ZMIANIE treści.
  // POST nowego komentarza na oś zdarzeń (orders_actions.py) — bez edycji cudzych;
  // listing pokazuje ostatni comment_added jako internal_note.
  async function _pmSaveNote(ta: HTMLTextAreaElement) {
    if (!_pmSession) return;
    // Review serii: sesja może zostać wyzerowana W TRAKCIE awaita (Anuluj tuż po
    // blurze) — pracuj na lokalnej referencji; DOM aktualizuj tylko gdy modal żywy.
    var sess = _pmSession;
    var val = String(ta.value || '').trim();
    if (val === String(sess.noteBaseline || '') || !val) return;
    var order = sess.order;
    var w = window as any;
    var apiId = (w.__sbExports && typeof w.__sbExports.getOrderApiId === 'function')
      ? w.__sbExports.getOrderApiId(order) : String(order.id || '');
    try {
      var r = await _fetchWT('/api/orders/' + encodeURIComponent(apiId) + '/comments', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + _pmTok(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: val }),
      });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      sess.noteBaseline = val;
      try { order.internal_note = { text: val, author: 'Ty', count: ((order.internal_note && order.internal_note.count) || 0) + 1 }; } catch (_: any) {}
      // Animacje ze spec: badge „✓ zapisano" (noteSaved .34s) + flash ramki (1.1s)
      var slot = document.getElementById('pm-note-saved-slot');
      if (slot) {
        slot.innerHTML = '<span class="pm-note-saved"><i data-lucide="check" style="width:10px;height:10px"></i> zapisano</span>';
        if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [slot] }); } catch (_: any) {} }
        setTimeout(function() { if (slot) slot.innerHTML = ''; }, 2200);
      }
      ta.classList.remove('flash');
      void ta.offsetWidth; // restart animacji
      ta.classList.add('flash');
    } catch (e: any) {
      showToast('Nie udało się zapisać notatki — spróbuj ponownie', 'error');
    }
  }

  // Seria #3 (user): błąd nadania z poziomu pakowania = toast z TREŚCIĄ błędu
  // (odczyt z #wza-m-error modala WzA, fallback na komunikat ogólny) + otwarcie
  // drawera tego zamówienia NAD modalem (bump z-index w body.packing-mode).
  // Logika flow (watcher, token) celowo NIETKNIĘTA — to tylko sygnalizacja+skrót.
  function _pmBladNadania(orderId: any, fallbackMsg: string) {
    var msg = '';
    try {
      var el = document.getElementById('wza-m-error');
      if (el && el.textContent) msg = String(el.textContent).trim();
    } catch (_: any) {}
    try { showToast(msg || fallbackMsg, 'error'); } catch (_: any) {}
    try {
      var w: any = window;
      var f = (w.__sbExports && w.__sbExports.showOrderDetail) || w.showOrderDetail;
      if (typeof f === 'function') f(orderId);
    } catch (_: any) {}
  }

  // Zamknięcie modala: WYŁĄCZNIE Anuluj/✕ (decyzja usera; backdrop nie zamyka).
  // Przy zebranych pozycjach — potwierdzenie (postęp zbierania się zeruje).
  async function _pmRequestCancel() {
    var orderId = state.packingOrderId;
    if (!orderId) return;
    // Review serii #3: Esc z focus trapa łapie się na document przez całą
    // sesję — gdy NAD modalem wisi drawer produktu/zamówienia, Esc należy do
    // drawera, nie do anulowania pakowania (kasowało postęp + ubijało watchera).
    // Flaga z fazy CAPTURE (niżej) łapie też kolejność „drawer zamknął się
    // PRZED trapem" — wtedy klasa open już zdjęta i sam class-guard nie starcza.
    if (_pmEscDrawerGuard) return;
    var _pd = document.getElementById('product-drawer');
    var _od = document.getElementById('order-drawer');
    if ((_pd && _pd.classList.contains('open')) || (_od && _od.classList.contains('open'))) return;
    var progress = !!(_pmSession && _pmSession.positions && _pmSession.positions.some(function(p: any) { return p.confirmed; }));
    if (progress) {
      var w = window as any;
      var cf = (w.__sbExports && w.__sbExports.showConfirm) || w.showConfirm;
      if (typeof cf === 'function') {
        var ok = await cf('Przerwać pakowanie?', 'Część pozycji jest już zebrana — postęp zbierania zostanie wyzerowany. Notatka do zamówienia zostaje zapisana.', { danger: true });
        if (!ok) return;
      }
    }
    _cancelPacking(orderId);
  }

  // Esc nad drawerem (produkt/zamówienie) NIE anuluje pakowania — capture
  // odpala się PRZED bubble-handlerami drawera i focus trapa, więc flaga jest
  // ustawiona zanim którykolwiek z nich zdejmie klasę `open`.
  var _pmEscDrawerGuard = false;

  // Jednorazowe bindy delegowane modala (markup renderuje się wielokrotnie).
  function _pmBindDelegates() {
    var drawer: any = document.getElementById('packing-drawer');
    if (!drawer || drawer._pmBound) return;
    drawer._pmBound = true;
    document.addEventListener('keydown', function(e: any) {
      if (e.key !== 'Escape') return;
      // E5 §5.3: Esc nad panelem wyboru skanu zamyka PANEL, nie pakowanie.
      // Ta sama flaga co dla drawerów — focus trap modala woła `_pmRequestCancel`
      // (patrz `_closeFn` przy `createFocusTrap`), więc samo `stopPropagation`
      // z fazy bąbelkowania by nie wystarczyło.
      if (document.querySelector('#packing-drawer-body .pm-scan-choice')) {
        _pmEscDrawerGuard = true;
        setTimeout(function() { _pmEscDrawerGuard = false; }, 0);
        _pmScanZamknijWybor(true);
        return;
      }
      var pd = document.getElementById('product-drawer');
      var od = document.getElementById('order-drawer');
      if ((pd && pd.classList.contains('open')) || (od && od.classList.contains('open'))) {
        _pmEscDrawerGuard = true;
        setTimeout(function() { _pmEscDrawerGuard = false; }, 0);
      }
    }, true);
    drawer.addEventListener('click', function(e: any) {
      var t = e.target;
      if (!t || !t.closest) return;
      var nav = t.closest('.pm-gallery-nav');
      if (nav) {
        e.stopPropagation();
        var pos = _pmFindPos(nav.getAttribute('data-pos'));
        if (pos && pos.imgs.length > 1) {
          var dir = parseInt(nav.getAttribute('data-dir') || '1', 10) || 1;
          pos.imgIdx = ((pos.imgIdx || 0) + dir + pos.imgs.length) % pos.imgs.length;
          var wrap = drawer.querySelector('.pm-gal-wrap[data-pos="' + pos.key + '"]');
          if (wrap) {
            wrap.innerHTML = _pmGalleryHtml(pos);
            if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [wrap] }); } catch (_: any) {} }
            _pmCenterThumbs(wrap);
          }
        }
        return;
      }
      var th = t.closest('.pm-thumb[data-pos]');
      if (th) {
        e.stopPropagation();
        var pos2 = _pmFindPos(th.getAttribute('data-pos'));
        if (pos2) {
          pos2.imgIdx = parseInt(th.getAttribute('data-idx') || '0', 10) || 0;
          var wrap2 = drawer.querySelector('.pm-gal-wrap[data-pos="' + pos2.key + '"]');
          if (wrap2) {
            wrap2.innerHTML = _pmGalleryHtml(pos2);
            if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [wrap2] }); } catch (_: any) {} }
            _pmCenterThumbs(wrap2);
          }
        }
        return;
      }
      var kbtn = t.closest('.pm-komp-toggle[data-pos]');
      if (kbtn) {
        e.stopPropagation();
        var kpos = _pmFindPos(kbtn.getAttribute('data-pos'));
        if (kpos) { if (kpos.confirmed) _pmRestore(kpos.key); else _pmConfirm(kpos.key); }
        return;
      }
      var cbtn = t.closest('.pm-confirm-btn[data-pos]');
      if (cbtn) { e.stopPropagation(); _pmConfirm(cbtn.getAttribute('data-pos')); return; }
      var rbtn = t.closest('.pm-restore-btn[data-pos]');
      if (rbtn) { e.stopPropagation(); _pmRestore(rbtn.getAttribute('data-pos')); return; }
      var ditem = t.closest('.pm-status-item--done[data-pos]');
      if (ditem) { e.stopPropagation(); _pmRestore(ditem.getAttribute('data-pos')); return; }
      var opb = t.closest('.pm-open-product[data-product-id]');
      if (opb) {
        e.stopPropagation();
        _pmOpenProduct(opb.getAttribute('data-product-id'));
        return;
      }
      var scb = t.closest('.pm-scanean-btn[data-pos]');
      if (scb) {
        e.stopPropagation();
        // E5 §5.4: przycisk przestaje być zapowiedzią — ustawia fokus na polu
        // skanu SWOJEJ pozycji (skaner pisze do pola jak klawiatura). Pole
        // szukamy po `getAttribute`, nie przez selektor sklejony z klucza.
        var kluczPoz = scb.getAttribute('data-pos');
        var pola = drawer.querySelectorAll('.pm-scan[data-pos]');
        for (var si = 0; si < pola.length; si++) {
          if (pola[si].getAttribute('data-pos') === kluczPoz) {
            try { (pola[si] as HTMLInputElement).focus(); (pola[si] as HTMLInputElement).select(); } catch (_: any) {}
            break;
          }
        }
        return;
      }
      var nimg = t.closest('.pm-note-img[data-full]');
      if (nimg) {
        e.stopPropagation();
        var full = _pmSafeHttp(nimg.getAttribute('data-full'));
        if (full) full = adresPlikuPrywatnego(full);  // FIL-001: bieżący token medialny w chwili kliknięcia
        if (full) { try { window.open(full, '_blank', 'noopener'); } catch (_: any) {} }
        return;
      }
    });
    drawer.addEventListener('keydown', function(e: any) {
      var sc = e.target && e.target.closest && e.target.closest('.pm-scan');
      if (!sc) return;
      // [RECENZJA E5] Panel wyboru zostawia fokus w polu skanu, więc cyfrę 1-9 (wybór
      // pozycji) łapiemy TU, zanim trafi do wartości pola. Enter = skan jak dotąd.
      if (_pmScanCyfraWyboru(e)) return;
      if (e.key !== 'Enter') return;
      e.preventDefault();
      _pmScan(sc);
    });
    // blur nie bąbelkuje — focusout tak.
    drawer.addEventListener('focusout', function(e: any) {
      var ta = e.target;
      if (ta && ta.classList && ta.classList.contains('pm-order-note')) _pmSaveNote(ta);
    });
    var cancelBtn = document.getElementById('pm-cancel-btn');
    if (cancelBtn) cancelBtn.addEventListener('click', function() { _pmRequestCancel(); });
    var closeBtn = document.getElementById('pm-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', function() { _pmRequestCancel(); });
  }

  // Otwarcie drawera produktu z modala pakowania — lazy import products.ts
  // (wzorzec z delegatu „Dodaj lokalizację" w orders-shared.ts); drawer wychodzi
  // NAD modal przez bump z-index w body.packing-mode (style.css).
  async function _pmOpenProduct(pidRaw: any) {
    var pid = parseInt(String(pidRaw || ''), 10);
    if (!pid) return;
    var w: any = window;
    if (typeof w.openProductDrawer !== 'function') {
      try { await import('./products.ts'); } catch (_e: any) { return; }
    }
    if (typeof w.openProductDrawer === 'function') w.openProductDrawer(pid);
  }

  // Komentarze produktu (drawer produktu → product_comments) + galeria zdjęć
  // (products.images_json): JEDEN przebieg po unikalnych product_id przy otwarciu,
  // jeden wspólny re-render po skompletowaniu wszystkiego.
  function _pmFetchExtras(orderId: any) {
    if (!_pmSession) return;
    var pids: string[] = [];
    _pmSession.positions.forEach(function(p: any) {
      if (p.pid && pids.indexOf(String(p.pid)) === -1) pids.push(String(p.pid));
    });
    if (!pids.length) return;
    var jobs = pids.map(function(pid: string) {
      return Promise.all([
        SellBaseAPI.getProductComments(pid).catch(function() { return null; }),
        _fetchWT('/api/products/' + encodeURIComponent(pid), {
          headers: { 'Authorization': 'Bearer ' + _pmTok() },
        }).then(function(r: any) { return r.ok ? r.json() : null; }).catch(function() { return null; }),
      ]).then(function(res: any[]) {
        return { pid: pid, comments: res[0], product: res[1] };
      });
    });
    Promise.all(jobs).then(function(results: any[]) {
      // Sesja mogła się zamknąć / zmienić zamówienie w trakcie fetchu.
      if (!_pmSession || String(_pmSession.orderId) !== String(orderId)) return;
      results.forEach(function(r: any) {
        var comments = (r.comments && (r.comments.comments || r.comments)) || [];
        if (Array.isArray(comments) && comments.length) {
          _pmSession.commentsByPid[r.pid] = comments;
        }
        var extra: string[] = [];
        if (r.product) {
          try {
            var decoded = JSON.parse(String(r.product.images_json || '[]'));
            if (Array.isArray(decoded)) decoded.forEach(function(u: any) {
              var s = String(u || '').trim();
              if (s && extra.indexOf(s) === -1) extra.push(s);
            });
          } catch (_: any) {}
        }
        _pmSession.positions.forEach(function(p: any) {
          if (String(p.pid) !== r.pid) return;
          if (r.product && r.product.location && !p.location) p.location = String(r.product.location);
          extra.forEach(function(u: string) { if (p.imgs.indexOf(u) === -1) p.imgs.push(u); });
        });
      });
      _pmRenderAll();
    });
  }

  async function _renderPackingContent(orderId: any) {
    var body = document.getElementById('packing-drawer-body');
    var title = document.getElementById('packing-drawer-title');
    if (!body) return;

    // Review serii: bindy MUSZĄ wejść przed jakimkolwiek early-returnem —
    // inaczej przy „Nie znaleziono zamówienia" Anuluj/✕ były martwe (modal
    // nie do zamknięcia bez F5).
    _pmBindDelegates();
    var completeBtnEarly = document.getElementById('packing-complete-btn');
    if (completeBtnEarly && !(completeBtnEarly as any)._packBound) {
      (completeBtnEarly as any)._packBound = true;
      completeBtnEarly.addEventListener('click', function() {
        if (state.packingOrderId) _completePacking(state.packingOrderId);
      });
    }

    body.innerHTML = '<div style="padding:40px;text-align:center;color:var(--pk-t3)"><i data-lucide="loader-2" style="width:20px;height:20px;animation:spin 1s linear infinite"></i></div>';
    if (typeof lucide !== 'undefined') { try { lucide.createIcons({ nodes: [body] }); } catch (_: any) {} }

    // Find order in state first, then fallback to API
    var order: any = null;
    if ((window as any).SellBaseData && SellBaseData.getOrderById) {
      order = SellBaseData.getOrderById(orderId);
    }
    if (!order) {
      var allOrders = ((window as any).SellBaseData && SellBaseData.orders) || [];
      for (var i = 0; i < allOrders.length; i++) {
        if (allOrders[i].id === orderId) { order = allOrders[i]; break; }
      }
    }
    // Fallback: fetch from API
    if (!order) {
      try {
        var apiOrder = await SellBaseAPI.getOrder(orderId);
        if (apiOrder) order = normalizeBackendOrder(apiOrder);
      } catch (e: any) { /* ignore */ }
    }
    // Review serii: user mógł w trakcie awaita przełączyć się na inne zamówienie
    // — spóźniony fetch NIE może nadpisać sesji/tytułu nowszego modala.
    if (state.packingOrderId !== orderId) return;
    if (!order) {
      body.innerHTML = '<div style="padding:40px;text-align:center;color:var(--pk-t3)">Nie znaleziono zamówienia</div>';
      return;
    }

    let catalogPositions: any[] | null;
    _pmSession = null;
    await _pmWczytajZrodloZdjec();
    if (state.packingOrderId !== orderId) return;
    try {
      const inventory = await readCatalogInventory(String(order.public_id || orderId));
      if (state.packingOrderId !== orderId) return;
      catalogPositions = catalogPackingPositions(inventory);
      // 2026-09-25: skład katalogowy niesie tylko zdjęcie produktu — zdjęcie oferty dokładamy z pozycji
      // zamówienia (wg ustawienia firmy: „marketplace" = oferta pierwsza, „sellbase" = tylko gdy produkt bez zdjęcia).
      if (catalogPositions) {
        catalogPositions.forEach(function(p: any) {
          var oferta = zdjecieOfertyDlaPozycji(order, p);
          if (oferta) p.imgs = ulozZdjeciaPozycji(_pmZrodloZdjec, p.imgs || [], oferta);
          _pmOfertaPozycjiKatalogu(order, p);
        });
        // 2026-10-01: komponenty (taśma, śrubka) + karta sprzedana jako produkt, która dziś jest zestawem
        catalogPositions = uzupelnijPozycjeKatalogu(catalogPositions, mapaSkladuZPozycji(order.items),
          function(u: string) { return u ? [u] : []; });
        // Zgłoszenie #5: komponenty dziedziczą kontekst oferty — bez ikonki oferty (jak dotąd)
        catalogPositions.forEach(function(p: any) { if (p.komponent) p.offerUrl = ''; });
      }
    } catch (e) {
      if (state.packingOrderId !== orderId) return;
      body.innerHTML = '<div role="alert" style="padding:24px">Nie można przygotować listy pakowania: ' + escapeHtml((e as Error).message) + '</div>';
      return;
    }

    if (title) {
      var _dispId = String((order.short_no != null ? order.short_no : '') || order.public_id || String(order.id || '').replace(/^AL-/i, ''));  // 2026-09-04: nasze ID (numer SellBase)
      title.textContent = '#' + _dispId + (order.customer ? ' · ' + String(order.customer) : '');
    }

    _pmSession = {
      orderId: orderId,
      order: order,
      positions: catalogPositions || _pmBuildPositions(order),
      commentsByPid: {},
      noteBaseline: String((order.internal_note && order.internal_note.text) || '').trim(),
    };
    _pmBindDelegates();
    _pmRenderAll();
    _pmFetchExtras(orderId);

  }

  /**
   * 2026-05-25: pełen auto-flow "Spakowane — wyślij" dla WzA carrier.
   *
   * Flow:
   *  1. Otwórz modal WzA niewidocznie (stealth: opacity:0 + pointer-events:none)
   *  2. Czekaj na render + carrier auto-match (~2.3s total)
   *  3. Auto-click submit (modal robi POST + animację Generowanie→Wygenerowano→close)
   *  4. Po close modala → druk przez SellBase Print helper (best-effort)
   *  5. PUT status → 'shipped'
   *  6. Close packing drawer + re-render orders list (kafelek wpada do "Wysłane")
   *
   * Fallback: gdy walidator klient-side wykryje błąd / brak danych / submit disabled —
   * pokaż modal user'owi w trybie manual (opacity przywrócona).
   */
  // 2026-09-02 (statystyki zespołu): błąd AUTOMATU (etykieta/status) idzie do
  // raportu jako osobna kategoria, nie jako „anulowane przez pakowacza".
  // Fire-and-forget — telemetria nigdy nie blokuje pakowania.
  function _zglosBladAutomatu(orderId: any, reason: string): void {
    try {
      var tok = (window as any).SellBaseAPI && (window as any).SellBaseAPI.getAuthToken && (window as any).SellBaseAPI.getAuthToken();
      var raw = String(orderId || '').replace(/^AL-/i, '');
      void fetch('/api/packing/session/error', {
        method: 'POST', keepalive: true,
        headers: { 'Authorization': 'Bearer ' + (tok || ''), 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: raw.indexOf(':') >= 0 ? raw : raw.toLowerCase(), reason: String(reason || '').slice(0, 80) }),
      }).catch(function () { /* telemetria */ });
    } catch (_e) { /* telemetria */ }
  }

  async function _autoSpakowaneWzAFlow(orderObj: any, orderId: any, btn: any, autoFn: any, setStatus: any) {
    var w = window as any;
    // 2026-06-10 BUGFIX: zajmij token aktywnego flow dla tego orderId. Kolejny klik
    // SPAKOWANE dla tego samego orderId (przy zywym watcherze) NADpisze token i
    // przejmie kontrole — stary watcher/_finishFlow sprawdza token i cicho rezygnuje,
    // wiec NIE bedzie podwojnego wydruku ani podwojnego PUT statusu.
    _activeFlowOrderId = orderId;
    function _restoreBtn() {
      // Sprint 24: zawsze zdejmuj body class stealth — gwarantuje cleanup nawet
      // gdy autoFn rzucił przed lub po stealth setup.
      try { document.body.classList.remove('sb-stealth-modal'); } catch (_) {}
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = '<i data-lucide="package-check" style="width:16px;height:16px"></i> SPAKOWANE — WYŚLIJ';
        try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
      }
    }
    // 2026-06-10 BUGFIX: gdy uzbrajamy watchera (user dokonczy nadanie recznie w modalu),
    // NIE odblokowuj przycisku do stanu "kliknij ponownie" — ponowny klik startowalby
    // drugi flow + drugi stealth modal. Zostaw przycisk disabled z czytelnym labelem;
    // watcher sam dokonczy druk+status po nadaniu.
    function _btnWatching() {
      try { document.body.classList.remove('sb-stealth-modal'); } catch (_) {}
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<i data-lucide="loader-2" style="width:16px;height:16px;animation:spin 1s linear infinite"></i> Czekam na nadanie w modalu…';
        try { w.lucide && w.lucide.createIcons({ nodes: [btn] }); } catch (_) {}
      }
    }
    // 2026-06-22 BUGFIX: gdy watcher KOŃCZY bez dokończenia flow (user porzucił modal /
    // nie da się zweryfikować przesyłki), MUSI zwolnić token i odblokować przycisk —
    // inaczej zatruty _activeFlowOrderId ubijał auto-flow kolejnych zamówień (F5 naprawiał),
    // a przycisk starego zamówienia zostawał na zawsze disabled „Czekam na nadanie…".
    function _releaseFlow() {
      if (_activeFlowOrderId === orderId) _activeFlowOrderId = null;
      _restoreBtn();
    }

    // 2026-06-10: liczba przesyłek PRZED flow — baseline dla watchera ręcznego
    // "Nadaj" (odróżnia "user nadał i zamknął modal" od "user porzucił modal").
    async function _fetchShipCount(): Promise<number | null> {
      try {
        var tk = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
        var r = await _fetchWT('/api/allegro/wza/shipments?order_id=' + encodeURIComponent(orderId), {
          headers: { 'Authorization': 'Bearer ' + tk },
        });
        if (!r.ok) return null;
        var j = await r.json();
        var ss = (j && (j.shipments || j.items)) || [];
        // S-25 (25.09): szkic (niepewne nadanie — Allegro nie potwierdziło) NIE jest dowodem nadania.
        // Wcześniej szkic kasowano, teraz zostaje do uzgodnienia — bez tego filtra „przybył” jako nowa przesyłka.
        return Array.isArray(ss) ? ss.filter(function(s: any) { return String((s && s.status) || '').toLowerCase() !== 'draft'; }).length : null;
      } catch (_) { return null; }
    }
    // 2026-06-10 BUGFIX: baseline pobierany SYNCHRONICZNIE (await) PRZED uzbrojeniem
    // watchera. Wczesniej fire-and-forget — gdy baseline padl (null) heurystyka
    // `count>0` byla ZAWSZE prawdziwa dla zamowienia z istniejaca przesylka → po
    // PORZUCENIU modalu watcher drukowal STARA etykiete i ustawial "wysłane" mimo
    // braku nadania. Teraz null = nieznany baseline → NIE zgadujemy.
    var _baselineShips: number | null = await _fetchShipCount();

    // 2026-07-08 AUTO-ETYKIETY: pre-check — worker auto-labels mógł już nadać przesyłkę
    // i zbuforować etykietę Z GÓRY. Aktywna przesyłka WzA (created/label_generated
    // z wza_shipment_id) → pomijamy stealth-modal całkowicie i od razu Faza 2+3
    // (druk + status). To jest cały sens funkcji: zero lagu generowania.
    try {
      var tk0 = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
      var r0 = await _fetchWT('/api/allegro/wza/shipments?order_id=' + encodeURIComponent(orderId), {
        headers: { 'Authorization': 'Bearer ' + tk0 },
      });
      if (r0.ok) {
        var j0 = await r0.json();
        var ss0 = (j0 && (j0.shipments || j0.items)) || [];
        var active0 = (Array.isArray(ss0) ? ss0 : []).filter(function(s0: any) {
          var st0 = String((s0 && s0.status) || '').toLowerCase();
          return !!(s0 && s0.wza_shipment_id) && (st0 === 'created' || st0 === 'label_generated');
        });
        if (active0.length > 0) {
          if (btn) btn.disabled = true;
          setStatus('zap', 'Etykieta gotowa z góry (auto-etykiety) — drukuję…', 'var(--color-primary)');
          await _finishFlow(true);
          return;
        }
      }
    } catch (_) { /* pre-check best-effort — brak odpowiedzi = normalny flow z modalem */ }

    // 2026-06-10: gdy auto-submit padł na walidacji i user dostał modal do ręcznego
    // poprawienia — flow NIE kończy się, tylko czeka w tle. Gdy user kliknie Nadaj
    // (modal znika + przybyła przesyłka), automatycznie dokańczamy druk + status +
    // cleanup. Wcześniej user poprawiał adres, nadawał, a flow zostawiał zamówienie
    // w "Nowe" bez druku — i trzeba było wszystko klikać ręcznie.
    var _watcherArmed = false;
    function _watchManualNadaj() {
      if (_watcherArmed) return;
      _watcherArmed = true;
      (async function() {
        for (var t = 0; t < 600; t++) { // max 10 min
          await new Promise(function(r) { setTimeout(r, 1000); });
          if (_activeFlowOrderId !== orderId) return; // token przejety/zwolniony — drugi flow rzadzi
          if (state.packingOrderId !== orderId) { _releaseFlow(); return; } // user anulował / przeszedł dalej
          if (document.getElementById('wza-shipment-modal')) continue; // modal wciąż otwarty
          // Modal zniknął — nadane czy porzucone?
          var count = await _fetchShipCount();
          // 2026-06-10 BUGFIX: baseline nieznany (null) → NIE zgaduj `count>0`.
          // Pokaz "sprawdz recznie" i NIE wolaj _finishFlow (unika fantomowego
          // wydruku starej etykiety + bledny status "wysłane" po porzuceniu modalu).
          if (count === null) {
            setStatus('alert-triangle', 'Nie udało się zweryfikować przesyłki — sprawdź ręcznie', 'var(--color-warning,#f59e0b)');
            _releaseFlow();
            return;
          }
          if (_baselineShips === null) {
            setStatus('alert-triangle', 'Nie znam stanu wyjściowego przesyłek — sprawdź ręcznie', 'var(--color-warning,#f59e0b)');
            _releaseFlow();
            return;
          }
          var created = count > _baselineShips;
          if (created) {
            if (btn) btn.disabled = true;
            setStatus('loader-2', 'Przesyłka nadana — dokańczam: druk + status…', 'var(--color-primary)');
            await _finishFlow(true);
          } else {
            _releaseFlow(); // zamknięty bez nadania → zwolnij token + odblokuj przycisk
          }
          return;
        }
      })();
    }

    // === Phase 1: stealth modal + auto-submit ===
    // Sprint 24 (2026-05-26): klasa body PRZED autoFn — CSS gate ukrywa modal
    // natychmiast po appendChild, zanim browser zdąży go wyrenderować (eliminuje
    // flash modal'a). Reguła w style.css: body.sb-stealth-modal #wza-shipment-modal { opacity:0; pointer-events:none }.
    document.body.classList.add('sb-stealth-modal');
    // 2026-06-10 FAILSAFE: stealth nie moze przezyc flow w ZADNYM scenariuszu
    // (rownolegle przebiegi, wyjatek w srodku, walidacja modala po auto-checku).
    // Wiszaca klasa = kazdy kolejny modal WzA niewidzialny az do F5 (bug ze
    // zdjecia 2026-06-10). Po 30s od startu flow klasa schodzi bezwarunkowo,
    // a ukryty modal — jesli wciaz jest — zostaje pokazany userowi.
    setTimeout(function() {
      if (!document.body.classList.contains('sb-stealth-modal')) return;
      document.body.classList.remove('sb-stealth-modal');
      var ovLate = document.getElementById('wza-shipment-modal');
      if (ovLate) { ovLate.style.opacity = ''; ovLate.style.pointerEvents = ''; }
      console.warn('[auto-spakowane] failsafe: sb-stealth-modal wisial >30s — zdjety');
    }, 30000);
    setStatus('loader-2', 'Generowanie etykiety…', 'var(--color-primary)');
    try { autoFn(orderObj); } catch (e) {
      document.body.classList.remove('sb-stealth-modal');
      setStatus('alert-circle', 'Błąd otwarcia modal — spróbuj ręcznie', 'var(--color-error,#ef4444)');
      _restoreBtn();
      if (_activeFlowOrderId === orderId) _activeFlowOrderId = null;
      return;
    }

    // 2026-06-10 BUGFIX: poll na render modalu zamiast sztywnych 400ms. openWzAShipmentModal
    // ma awaity przed appendChild — na wolnym laczu modal pojawial sie PO 400ms i flow
    // konczyl "Modal się nie otworzył", a modal wyskakiwal pozniej BEZ uzbrojonego watchera.
    // Pętla 20×250ms (max 5s) czeka na #wza-shipment-modal.
    var overlay: HTMLElement | null = null;
    for (var pm = 0; pm < 20; pm++) {
      await new Promise(function(r) { setTimeout(r, 250); });
      overlay = document.getElementById('wza-shipment-modal');
      if (overlay) break;
    }
    if (!overlay) {
      // Modal moze sie jeszcze pojawic (bardzo wolne lacze) — zdejmij stealth zeby
      // user go zobaczyl, i uzbroj watchera: gdy user nada recznie, dokonczymy flow.
      document.body.classList.remove('sb-stealth-modal');
      var ovLater = document.getElementById('wza-shipment-modal');
      if (ovLater) { ovLater.style.opacity = ''; ovLater.style.pointerEvents = ''; }
      setStatus('alert-triangle', 'Modal otwiera się wolno — gdy nadasz ręcznie, dokończę automatycznie', 'var(--color-warning,#f59e0b)');
      _btnWatching();
      _watchManualNadaj();
      return;
    }
    // Stealth: niewidoczny ale w DOM (modal needs submit handler attached)
    // (Klasa body.sb-stealth-modal już zapewnia opacity:0; opacity inline jako
    // backup w razie gdyby klasa została zdjęta zewnętrznie.)
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    (overlay as any).dataset.autoSpakowane = '1';

    // Wait extra for delivery services auto-match (async fetch from wzaState)
    await new Promise(function(r) { setTimeout(r, 1800); });

    var submitBtn = document.getElementById('wza-m-submit') as HTMLButtonElement;
    var errEl = document.getElementById('wza-m-error');
    var hasError = !!(errEl && errEl.style.display && errEl.style.display !== 'none');
    var submitDisabled = !submitBtn || submitBtn.disabled;

    if (submitDisabled || hasError) {
      // Walidator wykrył brak — zdejmij stealth gate i pokaż modal manualnie
      document.body.classList.remove('sb-stealth-modal');
      overlay.style.opacity = '';
      overlay.style.pointerEvents = '';
      delete (overlay as any).dataset.autoSpakowane;
      setStatus('alert-triangle', 'Uzupełnij dane w modalu i kliknij Nadaj — dokończę automatycznie', 'var(--color-warning,#f59e0b)');
      _pmBladNadania(orderId, 'Uzupełnij dane wysyłki — otwieram zamówienie');
      _btnWatching();
      _watchManualNadaj();
      return;
    }

    // Auto-click submit
    submitBtn.click();

    // Wait for modal close (success removes overlay; error keeps it visible)
    // 2026-06-10: dodatkowo przerywaj od razu gdy modal pokaze blad walidacji
    // (frontowa walidacja odpala sie PO naszym checku w T+1.8s — np. "ulica bez
    // numeru domu"); wczesniej flow czekal pelne 10s z niewidzialnym modalem.
    var closed = false;
    var validationError = false;
    for (var i = 0; i < 40; i++) {
      await new Promise(function(r) { setTimeout(r, 250); });
      if (!document.getElementById('wza-shipment-modal')) { closed = true; break; }
      var errNow = document.getElementById('wza-m-error');
      if (errNow && errNow.style.display && errNow.style.display !== 'none') { validationError = true; break; }
    }
    // S-25 (25.09): odpowiedzi serwera z kodem — nie „popraw dane”, tylko konkretny powód.
    var _kodBledu = String((document.getElementById('wza-m-error') as any)?.dataset?.kod || '');
    if (!closed && (_kodBledu === 'order_has_shipment' || _kodBledu === 'wza_niepewne')) {
      document.body.classList.remove('sb-stealth-modal');
      var ovK = document.getElementById('wza-shipment-modal');
      if (ovK) { ovK.style.opacity = ''; ovK.style.pointerEvents = ''; delete (ovK as any).dataset.autoSpakowane; }
      if (_kodBledu === 'order_has_shipment') {
        setStatus('alert-triangle', 'Zamówienie ma już przesyłkę — wydrukuj ją z karty zamówienia (druga etykieta tylko świadomie w oknie)', 'var(--color-warning,#f59e0b)');
        _pmBladNadania(orderId, 'Zamówienie ma już przesyłkę — sprawdź kartę zamówienia');
      } else {
        setStatus('alert-triangle', 'Allegro nie potwierdziło nadania — nie nadawaj ponownie, SellBase sprawdzi za kilka minut', 'var(--color-warning,#f59e0b)');
        _pmBladNadania(orderId, 'Nadanie niepewne — SellBase sprawdza w Allegro');
      }
      _btnWatching();
      _watchManualNadaj();
      return;
    }
    if (!closed) {
      // Walidacja/Allegro odmówiły submitu — modal został otwarty z błędem, pokaż go user'owi
      document.body.classList.remove('sb-stealth-modal');
      var ov = document.getElementById('wza-shipment-modal');
      if (ov) { ov.style.opacity = ''; ov.style.pointerEvents = ''; delete (ov as any).dataset.autoSpakowane; }
      setStatus('alert-circle',
        validationError ? 'Popraw dane w modalu i kliknij Nadaj — dokończę automatycznie' : 'Błąd Allegro — sprawdź modal',
        'var(--color-error,#ef4444)');
      _pmBladNadania(orderId, validationError ? 'Popraw dane wysyłki — otwieram zamówienie' : 'Błąd Allegro przy nadaniu — otwieram zamówienie');
      if (!validationError) _zglosBladAutomatu(orderId, 'wza_submit_failed');
      _btnWatching();
      _watchManualNadaj();
      return;
    }

    await _finishFlow(false);

    // === Fazy 2-4 jako funkcja — wołana z happy path ORAZ z watchera po ręcznym Nadaj ===
    // przesylkaZweryfikowana=true: caller już potwierdził AKTYWNĄ przesyłkę
    // (pre-check auto-etykiet / watcher liczący przyrost) — bez drugiej weryfikacji.
    async function _finishFlow(przesylkaZweryfikowana?: boolean) {
    // Token guard: dokładnie jeden wydruk i PUT statusu dla tego flow.
    if (_activeFlowOrderId !== orderId) return;
    _activeFlowOrderId = null;
    // === Phase 2: druk etykiety (best-effort — gdy helper online) ===
    // 2026-07-08: przycisk "Generuj etykietę" już wydrukował w tej sesji → pomiń
    // drugi wydruk (przejdź od razu do Phase 3: status).
    var _btnPrinted = !!_labelDoneByButton[orderId];
    // Przed zmianą statusu wymagamy potwierdzonej aktywnej przesyłki.
    var ships: any[] = [];
    try {
      var tok = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
      var resp = await _fetchWT('/api/allegro/wza/shipments?order_id=' + encodeURIComponent(orderId), {
        headers: { 'Authorization': 'Bearer ' + tok },
      });
      if (resp.ok) {
        var j = await resp.json();
        var _shRaw = (j && (j.shipments || j.items)) || [];
        if (Array.isArray(_shRaw)) ships = _shRaw;
      }
    } catch (e) { console.warn('[auto-spakowane] failed to fetch shipments', e); }
    // S-25 (25.09): 'draft' = niepewne nadanie (szkic czeka na uzgodnienie z Allegro) — nie jest etykietą.
    var _zleStatusy = ['cancelled', 'failed', 'error', 'rejected', 'returned', 'draft'];
    var aktywne = ships.filter(function(sh: any) {
      return _zleStatusy.indexOf(String(sh.status || '').toLowerCase()) < 0;
    });
    var _bezSzkicow = ships.filter(function(sh: any) { return String(sh.status || '').toLowerCase() !== 'draft'; });
    if (!przesylkaZweryfikowana) {
      // Dowód nadania: jest AKTYWNA przesyłka i (gdy znamy stan sprzed flow)
      // przybyła NOWA. Sam „modal zniknął" nie wystarcza.
      var _jestNowa = (_baselineShips == null) ? aktywne.length > 0 : _bezSzkicow.length > _baselineShips;
      if (!aktywne.length || !_jestNowa) {
        setStatus('alert-triangle', 'Brak potwierdzonej etykiety — status NIE zmieniony. Nadaj przesyłkę i kliknij ponownie.', 'var(--color-warning,#f59e0b)');
        _pmBladNadania(orderId, 'Brak potwierdzonej etykiety — sprawdź nadanie');
        _zglosBladAutomatu(orderId, 'label_not_confirmed');
        _restoreBtn();
        return;
      }
    }
    if (_btnPrinted) {
      setStatus('check-circle', 'Etykieta już wydrukowana — zmieniam status…', 'var(--color-primary)');
    } else {
      setStatus('printer', 'Drukowanie etykiety…', 'var(--color-primary)');
    }
    // Najnowsza AKTYWNA przesyłka (anulowana/odrzucona nie jest dowodem sukcesu).
    var sorted = aktywne.slice().sort(function(a: any, b: any) {
        return String(b.created_at || '').localeCompare(String(a.created_at || ''));
    });
    var shipmentId: string | null = sorted.length
      ? (sorted[0].id || sorted[0].shipment_id || null) : null;

    var _drukBladWzA = '';
    if (!_btnPrinted && shipmentId) {
      try {
        var printFn = (w.__sbExports && w.__sbExports.sellbasePrintShipmentLabel) || w.sellbasePrintShipmentLabel;
        if (typeof printFn === 'function') {
          var _wynikDruku2 = await printFn({ shipment_id: shipmentId, document_type: 'shipping_label', miejsce: 'pakowanie' });
          if (_wynikDruku2 && _wynikDruku2.ok && _wynikDruku2.printer) {
            try { showToast('Etykieta → ' + _wynikDruku2.printer, 'info'); } catch (_te) {}
          }
          if (!(_wynikDruku2 && _wynikDruku2.ok)) _drukBladWzA = String((_wynikDruku2 && _wynikDruku2.error) || 'helper offline');
        }
      } catch (e: any) {
        console.warn('[auto-spakowane] print failed (helper offline?)', e);
        _drukBladWzA = String((e && e.message) || 'błąd druku');
      }
    }

    // === Phase 3: status order → shipped ===
    setStatus('loader-2', 'Zmiana statusu na Wysłane…', 'var(--color-primary)');
    var statusChanged = false;
    try {
      var tok2 = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
      // 2026-06-10: orderId tutaj to display-id karty ("AL-<UUID uppercase>") —
      // endpoint statusu matchuje po surowym id z DB (lowercase, bez prefiksu).
      // Wysyłka display-id dawała 404 i status NIE zmieniał się na Wysłane.
      var rawOrderId = String((orderObj && (orderObj.source_order_id || orderObj.id)) || orderId || '')
        .replace(/^(AL|EB|ER|PS)-/i, '').toLowerCase();
      var stResp = await _fetchWT('/api/allegro/orders/' + encodeURIComponent(rawOrderId) + '/status', {
        method: 'PUT',
        headers: { 'Authorization': 'Bearer ' + tok2, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'shipped' }),
      });
      statusChanged = stResp.ok;
    } catch (e) { console.warn('[auto-spakowane] status change failed', e); }
    // 27.10.2026 (właściciel: „Wysłane” dla WSZYSTKICH członków grupy wysyłkowej przy pakowaniu): etykieta grupy nie
    // przestawia już członków, a PUT statusu wyżej zmienia tylko to zamówienie. Domknięcie jak „Pakuj zaznaczone”
    // (/label-printed): zamówienie już „Wysłane” zostaje bez zmian, członkowie aktywnej grupy → „Wysłane”, „Wysłał”
    // i „Spakował” = pakujący. Bez grupy to tylko wpis w historii. Best-effort — błąd nie cofa „Wysłane”.
    if (statusChanged && shipmentId) {
      try {
        var tok3 = (w.SellBaseAPI && w.SellBaseAPI.getAuthToken && w.SellBaseAPI.getAuthToken()) || localStorage.getItem('sellbase_token') || '';
        var grId = String((orderObj && (orderObj.source_order_id || orderObj.id)) || orderId || '')
          .replace(/^(AL|EB|ER|PS)-/i, '').toLowerCase();
        var grResp = await _fetchWT('/api/orders/' + encodeURIComponent(grId) + '/label-printed', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + tok3, 'Content-Type': 'application/json' },
          body: JSON.stringify({ shipment_id: shipmentId, printer: '' }),
        });
        if (!grResp.ok) console.warn('[auto-spakowane] domknięcie grupy wysyłkowej: HTTP ' + grResp.status);
      } catch (e) { console.warn('[auto-spakowane] domknięcie grupy wysyłkowej', e); }
    }

    // === Phase 4: wynik zależny od potwierdzonej zmiany statusu ===
    var processCompleted = false;
    var processError = '';
    if (statusChanged) {
      // WzA omija /api/packing/complete, więc dopiero po potwierdzonym PUT statusu
      // zapisujemy faktyczne zakończenie procesu. Otwarcie drawera pozostaje tylko
      // kontekstem pracy i nie może samo tworzyć akcji „spakowano".
      try {
        await _completePackingProcessSession(orderId, shipmentId);
        processCompleted = true;
      } catch (e: any) {
        processError = String((e && e.message) || e || 'nieznany błąd');
        console.error('[auto-spakowane] process session completion failed', e);
        try { showToast('Wysłano, ale nie zapisano czasu pakowania: ' + processError, 'warning'); } catch (_) {}
      }
      if (processCompleted) {
        setStatus('check-circle', '✓ Spakowane i wysłane!', 'var(--color-success,#22c55e)');
      } else {
        setStatus('alert-triangle', 'Wysłane, ale pomiar pakowania wymaga sprawdzenia', 'var(--color-warning,#f59e0b)');
      }
    } else {
      setStatus('alert-triangle', 'Etykieta wydrukowana, ale status NIE zmieniony — ustaw "Wysłane" ręcznie', 'var(--color-warning,#f59e0b)');
      _zglosBladAutomatu(orderId, 'status_push_failed');
    }
    // 21.10.2026 (audyt K7-01 / K7-3-U1): tor WzA ignorował nieudany druk — status „Wysłane” i okno się zamykało,
    // pakowacz bez etykiety w ręku tracił zamówienie z oczu. Jak w torze InPost (20.10): okno zostaje z „Drukuj ponownie”.
    if (_drukBladWzA && shipmentId) {
      setStatus('alert-triangle', (statusChanged ? 'Wysłane, ale etykieta NIE wydrukowana: ' : 'Etykieta NIE wydrukowana: ') + _drukBladWzA,
        'var(--color-warning,#f59e0b)');
      try { showToast('Etykieta NIE wydrukowana — kliknij „Drukuj ponownie” w oknie pakowania', 'warning'); } catch (_) {}
      await new Promise<void>(function (gotowe) {
        var _stEl = document.getElementById('packing-status');
        if (!_stEl) { gotowe(); return; }
        var _box = document.createElement('span');
        _box.style.cssText = 'display:inline-flex;gap:6px;margin-left:auto;flex-shrink:0';
        _box.innerHTML = '<button type="button" class="btn-primary btn-sm" id="pm-wza-druk-ponownie">'
            + '<i data-lucide="printer" style="width:14px;height:14px"></i> Drukuj ponownie</button>'
          + '<button type="button" class="btn-secondary btn-sm" id="pm-wza-druk-zamknij">Zamknij</button>';
        _stEl.appendChild(_box);
        try { (w.lucide && w.lucide.createIcons({ nodes: [_box] })); } catch (_) {}
        var _zamk = _box.querySelector('#pm-wza-druk-zamknij') as HTMLButtonElement | null;
        var _ponow = _box.querySelector('#pm-wza-druk-ponownie') as HTMLButtonElement | null;
        if (_zamk) _zamk.addEventListener('click', function () { gotowe(); });
        if (_ponow) _ponow.addEventListener('click', async function () {
          _ponow!.disabled = true;
          var _pf = (w.__sbExports && w.__sbExports.sellbasePrintShipmentLabel) || w.sellbasePrintShipmentLabel;
          var _wyn: any = null;
          try { _wyn = typeof _pf === 'function' ? await _pf({ shipment_id: shipmentId, document_type: 'shipping_label', miejsce: 'pakowanie' }) : null; } catch (_pe) { _wyn = null; }
          if (_wyn && _wyn.ok) {
            setStatus('check-circle', 'Etykieta wydrukowana — zamykam', 'var(--color-success,#22c55e)');
            setTimeout(gotowe, 800);
          } else {
            setStatus('alert-triangle', 'Etykieta NIE wydrukowana: ' + String((_wyn && _wyn.error) || 'helper offline'), 'var(--color-warning,#f59e0b)');
            var _stEl2 = document.getElementById('packing-status');
            if (_stEl2 && !_stEl2.contains(_box)) _stEl2.appendChild(_box);
            _ponow!.disabled = false;
          }
        });
      });
    }
    // Sprint 24 (2026-05-26): czerwony button "ANULUJ PAKOWANIE" → na chwilę
    // zielony "Zamówienie wysłane!" przed re-renderem (kafelek znika z listy "Nowe").
    try {
      var _packBtn = document.querySelector('.order-card[data-order-id="' + orderId + '"] .btn-pack-cancel') as HTMLElement | null;
      if (_packBtn) {
        _packBtn.style.background = 'var(--color-success, #22c55e)';
        _packBtn.style.color = '#fff';
        _packBtn.style.borderColor = 'var(--color-success, #22c55e)';
        _packBtn.innerHTML = '<i data-lucide="check-circle" style="width:12px;height:12px"></i> Zamówienie wysłane!';
        try { (w.lucide && w.lucide.createIcons({ nodes: [_packBtn] })); } catch (_) {}
      }
    } catch (_) {}
    await new Promise(function(r) { setTimeout(r, 1200); });

    // Close packing drawer — cleanup MUSI byc kompletny i odporny na wyjatki:
    // 2026-06-10: renderOrderCards() potrafil rzucic (kwota-string w formatCurrency)
    // i urywal reszte cleanupu → body.sb-stealth-modal zostawala na stronie i KAZDY
    // kolejny modal WzA (nadanie przesylki) byl niewidzialny az do F5.
    // 2026-08-26: zapamiętaj JEGO ostatnio spakowane zamówienie — chip
    // „Poprzednie" w stopce kolejnego pakowania pozwala szybko wrócić.
    _zapiszPoprzednie(orderId, orderObj);
    state.packingDrawerOpen = false;
    state.packingOrderId = null;
    delete state.packingLocks[orderId];
    document.body.classList.remove('sb-stealth-modal');
    var drawer = document.getElementById('packing-drawer');
    if (drawer) { drawer.classList.remove('open'); drawer.removeAttribute('data-order-id'); }
    // focus trap — parytet z _cancelPacking (bez tego stary trap zostawal aktywny)
    if (drawer && (drawer as any)._sbTrap) {
      try { (drawer as any)._sbTrap.deactivate(); } catch (_) {}
      (drawer as any)._sbTrap = null;
    }
    document.body.classList.remove('packing-mode');
    document.documentElement.classList.remove('packing-mode-html');
    _wrocDoMiejscaSprzedPakowania();
    document.querySelectorAll('.order-card.packing-active').forEach(function(c: any) { c.classList.remove('packing-active'); });
    _updatePackingButtons();
    // Status placeholder cleanup + restore PRZED renderem (render moze rzucic)
    var st = document.getElementById('packing-status');
    if (st) st.remove();
    _restoreBtn();
    // Zwolnij lock serwerowy (parytet z _cancelPacking; fire-and-forget)
    try { (w.SellBaseAPI && w.SellBaseAPI.releasePackingLock) && w.SellBaseAPI.releasePackingLock(orderId); } catch (_) {}
    // 2026-07-08: sprzątanie po przycisku "Generuj etykietę"
    delete _labelDoneByButton[orderId];
    try { var _glb = document.getElementById('packing-genlabel-btn'); if (_glb && _glb.parentNode) _glb.parentNode.removeChild(_glb); } catch (_) {}
    _pmResetSession();
    // PUT statusu nie aktualizuje store'u: wymuś refetch, potem pokaż skrót.
    // S-139 przegląd: wygaszamy tylko gdy PUT się faktycznie powiódł (statusChanged) —
    // nieudana zmiana statusu zostawia kartę (user ma ręcznie ustawić "Wysłane").
    _odswiezListeZamowienPoMutacji(orderId, statusChanged ? 'shipped' : null);
    _renderPoprzednieOkienko();
    } // koniec _finishFlow
  }

  // 27.10.2026 (właściciel: „Wysłane” tylko przy pakowaniu): `poEtykiecie` = etykietę utworzono przed chwilą
  // w oknie przewoźnika otwartym z PAKUJ (shipments.ts::_finalizePackingAfterShipment) — od razu domknięcie
  // /api/packing/complete w trybie istniejącej etykiety (status „Wysłane” + druk), bez ponownego pytania i routingu.
  async function _completePacking(orderId: any, opcje?: { poEtykiecie?: boolean }) {
    var poEtykiecie = !!(opcje && opcje.poEtykiecie);
    if (!_pmSession || String(_pmSession.orderId) !== String(orderId)) {
      showToast('Najpierw wczytaj i sprawdź skład zamówienia.', 'error');
      return;
    }
    // Z7: świeży status przed „Spakowane — wyślij” — anulowane = pasek, bez nadania i zmiany statusu
    if (await _pmSprawdzAnulowane(orderId)) { showToast(_pmTekstBlokady(orderId), 'error'); return; }
    // DECYZJA usera 2026-08-24: „Spakowane — wyślij" ZAWSZE aktywne. Gdy nie
    // wszystkie pozycje potwierdzone — potwierdzenie zamiast blokady; pełen
    // komplet idzie bez pytania. Dalej DOTYCHCZASOWA ścieżka wysyłki 1:1.
    if (!poEtykiecie && _pmSession && String(_pmSession.orderId) === String(orderId)) {
      var _pend = _pmSession.positions.filter(function(p: any) { return !p.confirmed; }).length;
      if (_pend > 0) {
        var _wcf = (window as any);
        var _cf = (_wcf.__sbExports && _wcf.__sbExports.showConfirm) || _wcf.showConfirm;
        if (typeof _cf === 'function') {
          var _okSend = await _cf('Wysłać mimo niepełnego zebrania?',
            'Niepotwierdzone pozycje: ' + _pend + ' z ' + _pmSession.positions.length + '. Kontynuować wysyłkę?',
            { danger: true });
          if (!_okSend) return;
        }
      }
    }
    var footer = document.getElementById('packing-drawer-footer');
    var btn = document.getElementById('packing-complete-btn');

    // Sprint 24 (2026-05-26): status loading INSIDE buttona zamiast nad nim.
    // Dla loader-2 zastępujemy treść przycisku spinnerem+tekstem (przycisk disabled).
    // Dla terminal states (success/error/warning) wracamy do paska nad buttonem
    // żeby user widział finalny komunikat po zwolnieniu przycisku.
    function _setPackStatus(icon: any, text: any, color: any) {
      if (!footer) return;
      var isLoading = (icon === 'loader-2');
      var packBtn = document.getElementById('packing-complete-btn') as HTMLButtonElement | null;
      var statusEl = document.getElementById('packing-status');

      if (isLoading && packBtn) {
        // Zapisz oryginalną treść przycisku raz, żeby przy następnych setStatus móc przywrócić.
        if (!(packBtn as any)._origHtml) (packBtn as any)._origHtml = packBtn.innerHTML;
        packBtn.disabled = true;
        packBtn.innerHTML =
          '<i data-lucide="loader-2" style="width:16px;height:16px;animation:spin 1s linear infinite;vertical-align:-3px"></i>' +
          ' <span>' + escapeHtml(text) + '</span>';
        if (typeof lucide !== 'undefined') lucide.createIcons({ nodes: [packBtn] });
        // Usuń ewentualny pasek nad buttonem z poprzedniego cyklu.
        if (statusEl && statusEl.parentNode) statusEl.parentNode.removeChild(statusEl);
        return;
      }

      // Terminal state — pokaż pasek nad buttonem (success/error/warning).
      if (!statusEl) {
        statusEl = document.createElement('div');
        statusEl.id = 'packing-status';
        // Seria #3 (user): status w JEDNEJ linii z Anuluj (order w CSS), większa czcionka
      statusEl.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:14px;font-weight:600;min-width:0';
        footer.insertBefore(statusEl, footer.firstChild);
      }
      statusEl.style.color = color || 'var(--color-text-muted)';
      statusEl.innerHTML = '<i data-lucide="' + icon + '" style="width:14px;height:14px;flex-shrink:0"></i><span>' + escapeHtml(text) + '</span>';
      if (typeof lucide !== 'undefined') lucide.createIcons({ nodes: [statusEl] });
    }

    var forceNext = !poEtykiecie && btn && (btn as any)._forceNext;
    if (forceNext) {
      // 21.10.2026 (audyt K7-3-U7): „Wygeneruj kolejną i wyślij” nadawało drugą PŁATNĄ etykietę jednym kliknięciem.
      // Teraz świadome potwierdzenie z fokusem na „Nie nadawaj” (Enter ze skanera nie przechodzi), jak w oknie WzA.
      var _wfk = (window as any);
      var _cfk = (_wfk.__sbExports && _wfk.__sbExports.showConfirm) || _wfk.showConfirm;
      var _trescK = 'Zamówienie ma już przesyłkę. Kolejna etykieta może zostać opłacona — nadaj ją tylko, jeśli naprawdę wysyłasz drugą paczkę.';
      // bez okna potwierdzenia (nie powinno się zdarzyć) — nie nadajemy: druga płatna etykieta tylko świadomie
      var _okK = typeof _cfk === 'function'
        ? await _cfk('Nadać drugą paczkę?', _trescK, { danger: true, okLabel: 'Nadaj kolejną paczkę', cancelLabel: 'Nie nadawaj' })
        : false;
      if (!_okK) return;
    }
    if (btn) { (btn as any).disabled = true; (btn as any)._forceNext = false; }

    // 2026-05-25: short-circuit dla WzA carrier — zamiast wołać /api/packing/complete
    // (które idzie wyłącznie do InPost), deleguj do _autoOrModalShipment który routuje
    // do WzA modal jeśli zamówienie ma carrier Allegro WzA. Spójne z drawer flow.
    if (!poEtykiecie) try {
      var w = window as any;
      var orderObj: any = null;
      if (w.SellBaseData && typeof w.SellBaseData.getOrderById === 'function') {
        try { orderObj = w.SellBaseData.getOrderById(orderId); } catch (_) {}
      }
      // S-180 (14.10.2026, właściciel: „jak etykieta jest wcześniej wygenerowana, to Spakowane — wyślij ma ją wydrukować
      // i zmienić status na wysłany”): szuflada pakowania pokazuje zamówienie także spoza listy w pamięci (fallback
      // SellBaseAPI.getOrder w _renderPackingContent → _pmSession.order). Bez tego obiektu trasa WzA (z pre-checkiem
      // „etykieta z góry → druk + Wysłane”) była pomijana i szło /api/packing/complete → 409 „ma już przesyłkę”.
      if (!orderObj && _pmSession && String(_pmSession.orderId) === String(orderId) && _pmSession.order) orderObj = _pmSession.order;
      var autoFn = (w.__sbExports && w.__sbExports._autoOrModalShipment) || w._autoOrModalShipment;
      var isWzA = false;
      // 2026-07-18 multi-marketplace: WzA to usługa Allegro — flow WzA TYLKO dla
      // source 'allegro'/'manual' (heurystyka po stringu metody wciągała nie-Allegro
      // z metodą "Allegro ..."). Pozostałe źródła idą generic InPost/modal.
      var _srcKey = String((orderObj && orderObj.source && orderObj.source.key) || 'allegro').toLowerCase();
      var _isAllegroSrc = (_srcKey === 'allegro' || _srcKey === 'manual' || _srcKey === '');
      if (orderObj && _isAllegroSrc) {
        try {
          var method = String((orderObj.delivery && orderObj.delivery.method) || orderObj.delivery_method || '').trim();
          if (method) {
            var wzaState = (w.__sbExports && w.__sbExports.wzaState) || (w.__sbStateExt && w.__sbStateExt.wzaState);
            var accId = orderObj.allegroAccountId || orderObj.allegro_account_id || orderObj.account_id;
            // Sprint 24 fix: jeśli wzaState.deliveryServices[accId] nie załadowane —
            // lazy fetch przez exposed _wzaLoadDeliveryServices (zachowuje cache 60min).
            // Bez tego: user kliknie SPAKOWANE-WYŚLIJ na Allegro Kurier DPD (WzA) zanim
            // ktoś wszedł na zakładkę WzA → kod padał na fallback InPost → błąd.
            var lazyLoadFn = (w.__sbExports && w.__sbExports._wzaLoadDeliveryServices) || w._wzaLoadDeliveryServices;
            var services = (wzaState && wzaState.deliveryServices && accId)
              ? (wzaState.deliveryServices[String(accId)] || []) : [];
            if (accId && !services.length && typeof lazyLoadFn === 'function') {
              _setPackStatus('loader-2', 'Sprawdzam metodę wysyłki…', 'var(--color-primary)');
              try { await lazyLoadFn(accId); } catch (_) {}
              wzaState = (w.__sbExports && w.__sbExports.wzaState) || (w.__sbStateExt && w.__sbStateExt.wzaState);
              services = (wzaState && wzaState.deliveryServices && wzaState.deliveryServices[String(accId)]) || [];
            }
            var lcMethod = method.toLowerCase();
            if (services.length && services.some(function(s: any) { return String(s.name || '').toLowerCase() === lcMethod; })) {
              isWzA = true;
            }
            // Heurystyka safety net: jeśli metoda zaczyna się od "allegro" — to WzA
            // (np. "Allegro Kurier DPD", "Allegro Paczkomaty"). Bez tego: pad na InPost.
            if (!isWzA && lcMethod.indexOf('allegro') === 0) {
              isWzA = true;
            }
          }
        } catch (_) { /* fallthrough */ }
      }
      if (isWzA && orderObj && typeof autoFn === 'function') {
        // 2026-05-25: pełen auto-flow WzA — stealth modal, click submit, print, status, close.
        _autoSpakowaneWzAFlow(orderObj, orderId, btn, autoFn, _setPackStatus);
        return;
      }
      // Sprint 24 (2026-05-26): elastyczny routing pod przewoźnika kupującego.
      // Detect InPost (paczkomat/inpost-kurier, NIE Allegro) → auto-flow przez
      // /api/packing/complete. Inne (DPD, UPS, FedEx, GLS, własne, brak metody) →
      // otwórz manualny modal "Wygeneruj przesyłkę" (autoFn = _autoOrModalShipment
      // sam zrouttuje na właściwy provider lub poprosi o uzupełnienie danych).
      if (orderObj) {
        try {
          var _m = String((orderObj.delivery && orderObj.delivery.method) || orderObj.delivery_method || '').toLowerCase().trim();
          var _hasPickup = !!(orderObj.delivery && (orderObj.delivery.pickup_point || orderObj.delivery.pickupPoint));
          var _isInPostNative = ((_m.indexOf('paczkomat') >= 0 || _m.indexOf('inpost') >= 0) && _m.indexOf('allegro') !== 0)
            || (!_isAllegroSrc && _hasPickup);
          // 27.10.2026 (właściciel): etykieta już jest (z karty, automatu, „Generuj etykietę”) → bez okna przewoźnika,
          // od razu /api/packing/complete niżej: backend bierze istniejącą przesyłkę (reuse), ustawia „Wysłane”
          // i zapisuje „Wysłał”/„Spakował”; front drukuje z „Drukuj ponownie” przy błędzie druku.
          var _maEtykiete = false;
          if (!_isInPostNative && typeof autoFn === 'function') {
            _setPackStatus('loader-2', 'Sprawdzam etykietę…', 'var(--color-primary)');
            var _stanEtykiety = await _fetchLabelState(orderId);
            _maEtykiete = !!(_stanEtykiety && _stanEtykiety.has_label);
          }
          if (!_isInPostNative && !_maEtykiete && typeof autoFn === 'function') {
            // Nie-InPost (np. DPD/UPS/FedEx) bez etykiety → manualny modal, user wybiera providera. Etykieta z okna
            // statusu nie zmienia — po jej utworzeniu shipments.ts woła _completePacking(orderId, {poEtykiecie: true}).
            _setPackStatus('package', 'Wybierz przewoźnika ręcznie…', 'var(--color-primary)');
            // Znacznik „okno przewoźnika otwarte ze Spakowane — wyślij”: tylko wtedy etykieta z okna domyka pakowanie
            // (inna etykieta z karty przy otwartym PAKUJ zostaje samą etykietą, bez „Wysłane”).
            w.__sbPakujOknoPrzewoznika = orderId;
            try { autoFn(orderObj); } catch (_) {}
            // Przywróć przycisk żeby user mógł kliknąć ponownie po zamknięciu modal
            if (btn) {
              (btn as any).disabled = false;
              btn.innerHTML = '<i data-lucide="package-check" style="width:16px;height:16px"></i> SPAKOWANE — WYŚLIJ';
              try { (w.lucide && w.lucide.createIcons({ nodes: [btn] })); } catch (_) {}
            }
            return;
          }
        } catch (_) { /* fallthrough do InPost auto */ }
      }
    } catch (e) {
      console.error('[packing] short-circuit failed, fallback to InPost endpoint', e);
    }

    _setPackStatus('loader-2', forceNext ? 'Generowanie kolejnej etykiety...' : (poEtykiecie ? 'Kończę pakowanie…' : 'Generowanie etykiety InPost...'), 'var(--color-primary)');

    var _drukNieudany = '';  // 20.10.2026: powód nieudanego druku — okno zostaje otwarte z „Drukuj ponownie”
    try {
      var payload: any = { order_id: orderId };
      if (forceNext) payload.allow_duplicate = 1;
      // 2026-07-08: przycisk "Generuj etykietę" już wydrukował → backend pomija print_job
      if (_labelDoneByButton[orderId]) payload.skip_print = 1;
      var result = await SellBaseAPI.completePacking(payload);

      if (result && result.process_session && result.process_session.ok === false) {
        var metricWarning = String(result.process_session.warning || 'brak kompletnego dowodu');
        console.error('[packing] process session completion failed:', metricWarning);
        showToast('Przesyłka gotowa, ale nie zapisano czasu pakowania: ' + metricWarning, 'warning');
      }
      // 27.10.2026 (runda 2): „Wysłane” wysyła na Allegro numer przesyłki i status (mapowanie z Ustawień) — gdy się nie
      // udało (wyłącznik, bezpiecznik, odmowa Allegro), pakowacz widzi powód; status w SellBase zostaje, ponowi automat.
      if (result && result.allegro_sync_warning) {
        showToast('Wysłane w SellBase — ' + String(result.allegro_sync_warning), 'warning');
      }

      if (payload.skip_print) {
        _setPackStatus('check-circle', 'Etykieta już wydrukowana — status zmieniony', 'var(--color-primary)');
      } else {
        // 2026-09-07 (zgłoszenie: sklep PrestaShop „nie drukuje etykiety"): ścieżka InPost
        // kończyła się na „Zlecanie druku…" — backend wstawiał print_job do kolejki, której
        // nic nie czyta (28 „pending" z 30 dni, zero „done"). Drukujemy TAK SAMO jak flow WzA
        // i przycisk „Generuj etykietę": z przeglądarki przez helper SellBase Print, z nazwą
        // drukarki w toaście; gdy helper offline — jasny komunikat zamiast cichej „sukcesu".
        _setPackStatus('loader-2', 'Drukowanie etykiety…', 'var(--color-primary)');
        var _shId = result && result.shipment && (result.shipment.id || result.shipment.shipment_id);
        if (_shId) {
          var _wynikDruku3 = await _drukujEtykietePakowania(_shId);
          if (_wynikDruku3 && !_wynikDruku3.ok) _drukNieudany = String(_wynikDruku3.error || 'helper offline');
        }
      }
      await new Promise(function(r) { setTimeout(r, 800); }); // Brief pause for UX

      // 20.10.2026 (pakowacz: „wyskakuje błąd, etykieta nie wydrukowana, a zamówienie znika całkowicie i trzeba go
      // szukać w zrealizowanych”): przy nieudanym druku okno ZOSTAJE otwarte z „Drukuj ponownie” — bez etykiety
      // w ręku pakowacz nie może stracić zamówienia z oczu (status „Wysłane” już ustawiony przez /api/packing/complete).
      if (_drukNieudany && _shId) {
        _setPackStatus('alert-triangle', 'Wysłane, ale etykieta NIE wydrukowana: ' + _drukNieudany, 'var(--color-warning, #f59e0b)');
        _pokazPonownyDruk(_shId, _zamknijPoSpakowaniu);
        try { showToast('Etykieta NIE wydrukowana — kliknij „Drukuj ponownie” w oknie pakowania', 'warning'); } catch (_te2) {}
        return;
      }

      _setPackStatus('check-circle', 'Spakowane! Tracking: ' + (result.tracking_number || '—'), 'var(--color-success, #22c55e)');

      // Auto-close after 1.5s
      setTimeout(_zamknijPoSpakowaniu, 1500);
      showToast('Zamówienie spakowane! Tracking: ' + (result.tracking_number || '—'), 'success');
      return;
    } catch (e: any) {
      _bladSpakowania(e);
    }

    function _zamknijPoSpakowaniu() {
        state.packingDrawerOpen = false;
        state.packingOrderId = null;
        delete state.packingLocks[orderId];
        var drawer = document.getElementById('packing-drawer');
        if (drawer) { drawer.classList.remove('open'); drawer.removeAttribute('data-order-id'); }
        document.body.classList.remove('packing-mode'); document.documentElement.classList.remove('packing-mode-html');
        _wrocDoMiejscaSprzedPakowania();
        document.querySelectorAll('.order-card.packing-active').forEach(function(c: any) { c.classList.remove('packing-active'); });
        _updatePackingButtons();
        _odswiezListeZamowienPoMutacji(orderId);
        // Clean status
        var st = document.getElementById('packing-status');
        if (st) st.remove();
        if (btn) { (btn as any).disabled = false; btn.innerHTML = '<i data-lucide="package-check" style="width:16px;height:16px"></i> SPAKOWANE — WYŚLIJ'; }
        // 2026-07-08: sprzątanie po przycisku "Generuj etykietę"
        delete _labelDoneByButton[orderId];
        try { var _glb3 = document.getElementById('packing-genlabel-btn'); if (_glb3 && _glb3.parentNode) _glb3.parentNode.removeChild(_glb3); } catch (_) {}
        _pmResetSession();
    }

    async function _drukujEtykietePakowania(shId: any): Promise<any> {
      try {
        var _w2 = window as any;
        var _printFn = (_w2.__sbExports && _w2.__sbExports.sellbasePrintShipmentLabel) || _w2.sellbasePrintShipmentLabel;
        if (typeof _printFn !== 'function') return null;
        var wynik = await _printFn({
          shipment_id: shId, document_type: 'shipping_label', miejsce: 'pakowanie',
          onCzekanie: function () { _setPackStatus('loader-2', 'Czekam na etykietę od przewoźnika…', 'var(--color-primary)'); },
        });
        if (wynik && wynik.ok && wynik.printer) {
          try { showToast('Etykieta → ' + wynik.printer, 'info'); } catch (_te) {}
        }
        return wynik;
      } catch (pe: any) {
        console.warn('[packing] print failed (helper offline?)', pe);
        return { ok: false, error: String((pe && pe.message) || pe || 'błąd druku') };
      }
    }

    function _pokazPonownyDruk(shId: any, zamknij: () => void) {
      // przesyłka nadana, status „Wysłane” ustawiony — ponowne „Spakowane” nadałoby DRUGĄ paczkę
      var packBtn = document.getElementById('packing-complete-btn') as HTMLButtonElement | null;
      if (packBtn) {
        packBtn.disabled = true;
        packBtn.innerHTML = '<i data-lucide="check" style="width:16px;height:16px"></i> WYSŁANE — ETYKIETA DO WYDRUKU';
        try { (window as any).lucide && (window as any).lucide.createIcons({ nodes: [packBtn] }); } catch (_) {}
      }
      var statusEl = document.getElementById('packing-status');
      if (!statusEl) return;
      var box = document.createElement('span');
      box.style.cssText = 'display:inline-flex;gap:6px;margin-left:auto;flex-shrink:0';
      box.innerHTML = '<button type="button" class="btn-primary btn-sm" id="pm-druk-ponownie">'
          + '<i data-lucide="printer" style="width:14px;height:14px"></i> Drukuj ponownie</button>'
        + '<button type="button" class="btn-secondary btn-sm" id="pm-druk-zamknij">Zamknij</button>';
      statusEl.appendChild(box);
      try { (window as any).lucide && (window as any).lucide.createIcons({ nodes: [box] }); } catch (_) {}
      var ponow = box.querySelector('#pm-druk-ponownie') as HTMLButtonElement | null;
      var zamk = box.querySelector('#pm-druk-zamknij') as HTMLButtonElement | null;
      if (zamk) zamk.addEventListener('click', function () { zamknij(); });
      if (ponow) ponow.addEventListener('click', async function () {
        ponow!.disabled = true;
        var wynik = await _drukujEtykietePakowania(shId);
        if (wynik && wynik.ok) {
          _setPackStatus('check-circle', 'Etykieta wydrukowana — zamykam', 'var(--color-success, #22c55e)');
          setTimeout(zamknij, 800);
          return;
        }
        _setPackStatus('alert-triangle', 'Etykieta dalej NIE wydrukowana: ' + String((wynik && wynik.error) || 'helper offline'), 'var(--color-warning, #f59e0b)');
        _pokazPonownyDruk(shId, zamknij);
      });
    }

    function _bladSpakowania(e: any) {
      var errMsg = (e && e.message) || 'Nieznany błąd';
      if (_bladAnulowania(e)) {  // Z7: 409 ORDER_CANCELLED z backendu — pasek, przyciski zostają wyłączone
        _setPackStatus('alert-circle', KOMUNIKAT_ANULOWANE, 'var(--color-error, #ef4444)');
        _pmOznaczAnulowane(orderId);
        return;
      }
      // S-25 (25.09): „ma już przesyłkę” (aktywna przesyłka innego przewoźnika, np. WzA z automatu) = dubel, nie błąd automatu.
      var maJuz = errMsg.indexOf('ma już przesyłkę') > -1;
      var isDuplicate = maJuz || errMsg.indexOf('aktywna przesyłka') > -1 || errMsg.indexOf('duplicate') > -1 || errMsg.indexOf('allow_duplicate') > -1;
      // Audyt Codex (INT-003, przegląd pakietu 2): nieustalony wynik poprzedniego nadania — decyzja człowieka w oknie
      // rozstrzygnięcia (api.js), nie błąd automatu i nie „kolejna paczka”.
      var kodNadania = String((e && e.detail && e.detail.code) || '');
      if (kodNadania === 'WYNIK_NIEUSTALONY' || kodNadania === 'OPERACJA_W_TOKU') {
        _setPackStatus('alert-triangle', errMsg, 'var(--color-warning, #f59e0b)');
        if (btn) (btn as any).disabled = false;
      } else if (kodNadania === 'WYKONANE_U_PARTNERA') {
        // Paczka potwierdzona ręcznie u przewoźnika (bez etykiety w SellBase): instrukcja zamiast „kolejnej” jako
        // jedynej drogi; druga paczka nadal możliwa, ale nazwana wprost.
        _setPackStatus('alert-triangle', errMsg, 'var(--color-warning, #f59e0b)');
        if (btn) {
          (btn as any).disabled = false;
          btn.innerHTML = '<i data-lucide="plus" style="width:14px;height:14px"></i> Nadaj drugą paczkę (świadomie)';
          (btn as any)._forceNext = true;
          if (typeof lucide !== 'undefined') lucide.createIcons({ nodes: [btn] });
        }
      } else if (isDuplicate) {
        _setPackStatus('alert-triangle', maJuz ? errMsg : 'Etykieta już istnieje dla tego zamówienia', 'var(--color-warning, #f59e0b)');
        if (btn) {
          (btn as any).disabled = false;
          btn.innerHTML = '<i data-lucide="plus" style="width:14px;height:14px"></i> Wygeneruj kolejną i wyślij';
          (btn as any)._forceNext = true;
          if (typeof lucide !== 'undefined') lucide.createIcons({ nodes: [btn] });
        }
      } else {
        _setPackStatus('alert-circle', errMsg, 'var(--color-error, #ef4444)');
        // Seria #3: toast + drawer zamówienia także dla błędów ścieżki InPost/complete
        _pmBladNadania(orderId, errMsg);
        // Błąd automatu = etykieta/status z winy systemu; blokada, dane adresowe,
        // brak konta kuriera to NIE jest błąd automatu (review 2026-09-02).
        if (!/blokad|pakuje:|adres|uzupełnij|popraw|brak konta|nie masz|kod pocztowy|telefon/i.test(errMsg)) {
          _zglosBladAutomatu(orderId, 'complete_failed');
        }
        if (btn) (btn as any).disabled = false;
      }
    }
  }

  async function _cancelPacking(orderId: any) {
    // 1. Najpierw uruchom animację zamykania (mirror animacji otwierania).
    //    API releasePackingLock pójdzie w tle — nie blokujemy UI.
    state.packingDrawerOpen = false;
    state.packingOrderId = null;
    var _mialBlokade = !state.packingPodglad;  // Z7: podgląd anulowanego nie wziął blokady
    state.packingPodglad = false;
    delete state.packingLocks[orderId];
    // 2026-07-08: sprzątanie po przycisku "Generuj etykietę" (anulowanie pakowania
    // NIE anuluje przesyłki — etykieta zostaje, "Spakowane" później ją reużyje)
    delete _labelDoneByButton[orderId];
    try { var _glb2 = document.getElementById('packing-genlabel-btn'); if (_glb2 && _glb2.parentNode) _glb2.parentNode.removeChild(_glb2); } catch (_) {}
    _pmResetSession();
    var drawer = document.getElementById('packing-drawer');
    if (drawer) { drawer.classList.remove('open'); drawer.removeAttribute('data-order-id'); }
    // Sprint 20.12 (a11y): cleanup focus trap
    if (drawer && (drawer as any)._sbTrap) {
      try { (drawer as any)._sbTrap.deactivate(); } catch (_) {}
      (drawer as any)._sbTrap = null;
    }
    // Remove packing mode
    document.body.classList.remove('packing-mode'); document.documentElement.classList.remove('packing-mode-html');
    _wrocDoMiejscaSprzedPakowania();
    document.querySelectorAll('.order-card.packing-active').forEach(function(c: any) { c.classList.remove('packing-active'); });
    _updatePackingButtons();
    _renderPoprzednieOkienko();
    // 2. Zwolnij blokadę w tle (fire-and-forget) — animacja już leci. Tylko gdy była wzięta (Z7).
    if (_mialBlokade) {
      try { await SellBaseAPI.releasePackingLock(orderId); } catch (e: any) { /* ignore */ }
    }
  }

  function _updatePackingButtons() {
    // Faza 62: batch update + skip no-op. PRZED: lucide.createIcons per-button (1000+ × parse SVG)
    // generowało lagi na sekundy przy 1000+ kartach po każdym pakuj/anuluj.
    // PO: jedno lucide.createIcons() na końcu, z listą tylko zmienionych btn-ów.
    var rows = document.querySelectorAll('.oc-packing-row');
    if (!rows.length) return;
    var changedBtns: any[] = [];
    rows.forEach(function(row: any) {
      var card = row.closest('.order-card');
      if (!card) return;
      var ordId = card.dataset.orderId;
      if (!ordId) return;
      var lock = state.packingLocks[ordId];
      var btn = row.querySelector('.btn-pack');
      if (!btn) return;

      // KAFELEK 2.0 (2026-08-24): przyciski w listwie zk-rail — klasa zk-pack-btn
      // musi przetrwać podmianę stanu (className jest nadpisywany w całości).
      var desiredClass, desiredDisabled, desiredHtml;
      if (lock && !lock.is_mine) {
        desiredClass = 'zk-pack-btn btn-pack btn-pack-locked';
        desiredDisabled = true;
        desiredHtml = '<i data-lucide="lock" style="width:18px;height:18px"></i>' + escapeHtml(lock.user_name);
      } else if (state.packingOrderId === ordId && !state.packingPodglad) {  // Z7: podgląd ≠ „pakuję”
        desiredClass = 'zk-pack-btn btn-pack btn-pack-cancel';
        desiredDisabled = false;
        desiredHtml = '<i data-lucide="x" style="width:18px;height:18px"></i>ANULUJ';
      } else {
        desiredClass = 'zk-pack-btn btn-pack btn-pack-start';
        desiredDisabled = false;
        desiredHtml = '<i data-lucide="package" style="width:20px;height:20px"></i>PAKUJ';
      }

      // Skip no-op: jeśli klasa się nie zmieniła, button jest już w żądanym stanie.
      // Lucide po pierwszym render zamienił <i data-lucide> na <svg>, więc innerHTML
      // stale comparison nie zadziała — używamy klasy jako sygnału stanu.
      if (btn.className === desiredClass && (btn as any).disabled === desiredDisabled) {
        return;
      }
      btn.className = desiredClass;
      (btn as any).disabled = desiredDisabled;
      btn.innerHTML = desiredHtml;
      changedBtns.push(btn);
    });
    // Jedna pętla createIcons dla wszystkich zmienionych buttonów (zamiast per-iteration).
    if (changedBtns.length && typeof lucide !== 'undefined') {
      try { lucide.createIcons({ nodes: changedBtns }); } catch (_: any) {}
    }
  }

  // ── Packing lock polling ──
  function _startPackingPoll() {
    if (state.packingPollInterval) return;
    _fetchPackingLocks(); // immediate
    // Audyt 2026-07-16: pauza gdy karta w tle (jedyny nieguardowany poller) —
    // ~120 zbędnych requestów/h/kartę mniej; odśwież przy powrocie do widoczności.
    state.packingPollInterval = setInterval(function() {
      if (typeof document !== 'undefined' && document.hidden) return;
      _fetchPackingLocks();
    }, 30000);
    if (typeof document !== 'undefined' && !state.packingVisibilityBound) {
      state.packingVisibilityBound = true;
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible' && state.packingPollInterval) _fetchPackingLocks();
      });
    }
  }

  function _stopPackingPoll() {
    if (state.packingPollInterval) {
      clearInterval(state.packingPollInterval);
      state.packingPollInterval = null;
    }
  }

  async function _fetchPackingLocks() {
    try {
      // Keepalive własnego procesu: blokada jest odświeżana tylko, gdy drawer
      // faktycznie pozostaje otwarty w widocznej karcie. Backend może dzięki temu
      // odróżnić aktywny kontekst od porzuconej sesji.
      if (state.packingOrderId && state.packingDrawerOpen && !state.packingPodglad && SellBaseAPI.acquirePackingLock) {
        // Z7: keepalive blokady niesie też status — 409 ORDER_CANCELLED = anulowane w trakcie pakowania
        try { await SellBaseAPI.acquirePackingLock(state.packingOrderId); } catch (_e: any) {
          if (_bladAnulowania(_e)) _pmOznaczAnulowane(state.packingOrderId);
          else if (_bladSpakowanePrzezInnego(_e)) _pmOznaczSpakowane(state.packingOrderId, String((_e.detail && _e.detail.message) || ''));  // S-222
        }
      }
      var data = await SellBaseAPI.getPackingLocks();
      var newLocks: Record<string, any> = {};
      (data.locks || []).forEach(function(l: any) {
        var lockData = { user_name: l.user_name, is_mine: l.is_mine, user_id: l.user_id };
        newLocks[l.order_id] = lockData;
        // Display-id listy ma prefix źródła; lock i metryka trzymają kanoniczne id.
        ['AL-', 'EB-', 'ER-', 'PS-', 'TT-', 'VH-'].forEach(function(prefix: string) {
          newLocks[prefix + l.order_id] = lockData;
        });
      });
      // Keep own lock if drawer is open (might not be in API response due to timing)
      if (state.packingOrderId && state.packingDrawerOpen && !state.packingPodglad && !newLocks[state.packingOrderId]) {
        newLocks[state.packingOrderId] = { user_name: 'Ty', is_mine: true };
      }
      var changed = JSON.stringify(newLocks) !== JSON.stringify(state.packingLocks);
      state.packingLocks = newLocks;
      if (changed) _updatePackingButtons();
    } catch (e: any) {
      // Silent — polling is fire-and-forget
    }
  }

  // Zamkniecie karty nie jest swiadomym anulowaniem. Bez autoryzowanego requestu
  // niczego nie udajemy — brak heartbeat oznaczy sesje jako abandoned.

  /* -----------------------------------------------
     Drawer Resize — uniwersalny resize lewą krawędzią
     ----------------------------------------------- */

// 2026-08-26: okienko „Poprzednio spakowane" wraca po F5 — localStorage je
// pamięta, więc rysujemy przy starcie modułu (gdy #view-orders już jest w DOM).
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { try { _renderPoprzednieOkienko(); } catch (_) {} });
  } else {
    setTimeout(function() { try { _renderPoprzednieOkienko(); } catch (_) {} }, 500);
  }
}

// ── EXPOSE: extracted functions (legacy backward-compat) ──
(window as any).SellBaseApp = (window as any).SellBaseApp || {};
(window as any)._cancelPacking = _cancelPacking; (window as any).SellBaseApp._cancelPacking = _cancelPacking;
(window as any)._completePacking = _completePacking; (window as any).SellBaseApp._completePacking = _completePacking;
(window as any)._fetchPackingLocks = _fetchPackingLocks; (window as any).SellBaseApp._fetchPackingLocks = _fetchPackingLocks;
(window as any).__sbCompletePackingProcessSession = _completePackingProcessSession;
// 27.10.2026: etykieta z okna przewoźnika otwartego z PAKUJ → domknięcie pakowania (status „Wysłane” + druk).
(window as any).__sbDokonczPakowaniePoEtykiecie = function (orderId: any) {
  (window as any).__sbPakujOknoPrzewoznika = null;
  return _completePacking(orderId, { poEtykiecie: true });
};
(window as any)._renderPackingContent = _renderPackingContent; (window as any).SellBaseApp._renderPackingContent = _renderPackingContent;
(window as any)._startPacking = _startPacking; (window as any).SellBaseApp._startPacking = _startPacking;
(window as any)._startPackingPoll = _startPackingPoll; (window as any).SellBaseApp._startPackingPoll = _startPackingPoll;
(window as any)._stopPackingPoll = _stopPackingPoll; (window as any).SellBaseApp._stopPackingPoll = _stopPackingPoll;
(window as any)._updatePackingButtons = _updatePackingButtons; (window as any).SellBaseApp._updatePackingButtons = _updatePackingButtons;
window.togglePacking = togglePacking; (window as any).SellBaseApp.togglePacking = togglePacking;

// ── ES Module exports ──
export {
  _cancelPacking, _completePacking, _fetchPackingLocks, _renderPackingContent,
  _startPacking, _startPackingPoll, _stopPackingPoll, _updatePackingButtons, togglePacking,
};
